const countries = {
  'en': {
    'af': { 'code': 'af', 'name': 'Afghanistan (‫افغانستان‬‎)', 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': 'Albania (Shqipëri)', 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': 'Algeria (‫الجزائر‬‎)', 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': 'American Samoa', 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': 'Andorra', 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': 'Angola', 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': 'Anguilla', 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': 'Antigua and Barbuda', 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': 'Argentina', 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': 'Armenia (Հայաստան)', 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': 'Aruba', 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': 'Australia', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': 'Austria (Österreich)', 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': 'Azerbaijan (Azərbaycan)', 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': 'Bahamas', 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': 'Bahrain (‫البحرين‬‎)', 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': 'Bangladesh (বাংলাদেশ)', 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': 'Barbados', 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': 'Belarus (Беларусь)', 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': 'Belgium (België)', 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': 'Belize', 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': 'Benin (Bénin)', 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': 'Bermuda', 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': 'Bhutan (འབྲུག)', 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': 'Bolivia', 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': 'Bosnia and Herzegovina (Босна и Херцеговина)',
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': 'Botswana', 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': 'Brazil (Brasil)', 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': 'British Indian Ocean Territory', 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': 'British Virgin Islands', 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': 'Brunei', 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': 'Bulgaria (България)', 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': 'Burkina Faso', 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': 'Burundi (Uburundi)', 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': 'Cambodia (កម្ពុជា)', 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': 'Cameroon (Cameroun)', 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': 'Canada', 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': 'Cape Verde (Kabu Verdi)', 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': 'Caribbean Netherlands', 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': 'Cayman Islands', 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': 'Central African Republic (République centrafricaine)',
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': 'Chad (Tchad)', 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': 'Chile', 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': 'China (中国)', 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': 'Christmas Island', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': 'Cocos (Keeling) Islands', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': 'Colombia', 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': 'Comoros (‫جزر القمر‬‎)', 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': 'Congo (Republic) (Congo-Brazzaville)',
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': 'Cook Islands', 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': 'Costa Rica', 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': 'Côte d’Ivoire', 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': 'Croatia (Hrvatska)', 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': 'Cuba', 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': 'Curaçao', 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': 'Cyprus (Κύπρος)', 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': 'Czech Republic (Česká republika)', 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': 'Denmark (Danmark)', 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': 'Djibouti', 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': 'Dominica', 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': 'Dominican Republic (República Dominicana)',
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': 'Ecuador', 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': 'Egypt (‫مصر‬‎)', 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': 'El Salvador', 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': 'Equatorial Guinea (Guinea Ecuatorial)',
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': 'Eritrea', 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': 'Estonia (Eesti)', 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': 'Ethiopia', 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': 'Falkland Islands (Islas Malvinas)', 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': 'Faroe Islands (Føroyar)', 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': 'Fiji', 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': 'Finland (Suomi)', 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': 'France', 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': 'French Guiana (Guyane française)', 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': 'French Polynesia (Polynésie française)',
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': 'Gabon', 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': 'Gambia', 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': 'Georgia (საქართველო)', 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': 'Germany (Deutschland)', 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': 'Ghana (Gaana)', 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': 'Gibraltar', 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': 'Greece (Ελλάδα)', 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': 'Greenland (Kalaallit Nunaat)', 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': 'Grenada', 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': 'Guadeloupe', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': 'Guam', 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': 'Guatemala', 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': 'Guernsey', 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': 'Guinea (Guinée)', 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': 'Guinea-Bissau (Guiné Bissau)', 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': 'Guyana', 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': 'Haiti', 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': 'Honduras', 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': 'Hong Kong (香港)', 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': 'Hungary (Magyarország)', 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': 'Iceland (Ísland)', 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': 'India (भारत)', 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': 'Indonesia', 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': 'Iran (‫ایران‬‎)', 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': 'Iraq (‫العراق‬‎)', 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': 'Ireland', 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': 'Isle of Man', 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': 'Israel (‫ישראל‬‎)', 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': 'Italy (Italia)', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': 'Jamaica', 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': 'Japan (日本)', 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': 'Jersey', 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': 'Jordan (‫الأردن‬‎)', 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': 'Kazakhstan (Казахстан)', 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': 'Kenya', 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': 'Kiribati', 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': 'Kosovo', 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': 'Kuwait (‫الكويت‬‎)', 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': 'Kyrgyzstan (Кыргызстан)', 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': 'Laos (ລາວ)', 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': 'Latvia (Latvija)', 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': 'Lebanon (‫لبنان‬‎)', 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': 'Lesotho', 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': 'Liberia', 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': 'Libya (‫ليبيا‬‎)', 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': 'Liechtenstein', 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': 'Lithuania (Lietuva)', 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': 'Luxembourg', 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': 'Macau (澳門)', 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': 'Macedonia (FYROM) (Македонија)', 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': 'Madagascar (Madagasikara)', 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': 'Malawi', 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': 'Malaysia', 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': 'Maldives', 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': 'Mali', 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': 'Malta', 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': 'Marshall Islands', 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': 'Martinique', 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': 'Mauritania (‫موريتانيا‬‎)', 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': 'Mauritius (Moris)', 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': 'Mayotte', 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': 'Mexico (México)', 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': 'Micronesia', 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': 'Moldova (Republica Moldova)', 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': 'Monaco', 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': 'Mongolia (Монгол)', 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': 'Montenegro (Crna Gora)', 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': 'Montserrat', 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': 'Morocco (‫المغرب‬‎)', 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': 'Mozambique (Moçambique)', 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': 'Myanmar (Burma) (မြန်မာ)', 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': 'Namibia (Namibië)', 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': 'Nauru', 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': 'Nepal (नेपाल)', 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': 'Netherlands (Nederland)', 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': 'New Caledonia (Nouvelle-Calédonie)', 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': 'New Zealand', 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': 'Nicaragua', 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': 'Niger (Nijar)', 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': 'Nigeria', 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': 'Niue', 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': 'Norfolk Island', 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': 'North Korea (조선 민주주의 인민 공화국)', 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': 'Northern Mariana Islands', 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': 'Norway (Norge)', 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': 'Oman (‫عُمان‬‎)', 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': 'Pakistan (‫پاکستان‬‎)', 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': 'Palau', 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': 'Palestine (‫فلسطين‬‎)', 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': 'Panama (Panamá)', 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': 'Papua New Guinea', 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': 'Paraguay', 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': 'Peru (Perú)', 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': 'Philippines', 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': 'Poland (Polska)', 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': 'Portugal', 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': 'Puerto Rico', 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': 'Qatar (‫قطر‬‎)', 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': 'Réunion (La Réunion)', 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': 'Romania (România)', 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': 'Russia (Россия)', 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': 'Rwanda', 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': 'Saint Barthélemy (Saint-Barthélemy)',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': 'Saint Helena', 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': 'Saint Kitts and Nevis', 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': 'Saint Lucia', 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': 'Saint Martin (Saint-Martin (partie française))',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': 'Saint Vincent and the Grenadines',
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': 'Samoa', 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': 'San Marino', 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': 'São Tomé and Príncipe (São Tomé e Príncipe)',
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': 'Senegal (Sénégal)', 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': 'Serbia (Србија)', 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': 'Seychelles', 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': 'Sierra Leone', 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': 'Singapore', 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': 'Sint Maarten', 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': 'Slovakia (Slovensko)', 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': 'Slovenia (Slovenija)', 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': 'Solomon Islands', 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': 'Somalia (Soomaaliya)', 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': 'South Africa', 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': 'South Korea (대한민국)', 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': 'South Sudan (‫جنوب السودان‬‎)', 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': 'Spain (España)', 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': 'Sri Lanka (ශ්‍රී ලංකාව)', 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': 'Sudan (‫السودان‬‎)', 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': 'Suriname', 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': 'Svalbard and Jan Mayen', 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': 'Swaziland', 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': 'Sweden (Sverige)', 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': 'Switzerland (Schweiz)', 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': 'Syria (‫سوريا‬‎)', 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': 'Taiwan (台灣)', 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': 'Tajikistan', 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': 'Tanzania', 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': 'Thailand (ไทย)', 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': 'Timor-Leste', 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': 'Togo', 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': 'Tokelau', 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': 'Tonga', 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': 'Trinidad and Tobago', 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': 'Tunisia (‫تونس‬‎)', 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': 'Turkey (Türkiye)', 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': 'Turkmenistan', 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': 'Turks and Caicos Islands', 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': 'Tuvalu', 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': 'United States', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': 'United Kingdom', 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': 'U.S. Virgin Islands', 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': 'Uganda', 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': 'Ukraine (Україна)', 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': 'Uruguay', 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': 'Uzbekistan (Oʻzbekiston)', 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': 'Vanuatu', 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': 'Vatican City (Città del Vaticano)', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': 'Venezuela', 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': 'Vietnam (Việt Nam)', 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': 'Wallis and Futuna', 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': 'Western Sahara (‫الصحراء الغربية‬‎)',
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': 'Yemen (‫اليمن‬‎)', 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': 'Zambia', 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': 'Zimbabwe', 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': 'Åland Islands', 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'jp': {
    'af': { 'code': 'af', 'name': 'アフガニスタン', 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': 'アルバニア', 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': 'アルジェリア', 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': 'Aアメリカ領サモア', 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': 'アンドラ', 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': 'アンゴラ', 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': 'アンギラ', 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': 'アンティグア・バーブーダ', 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': 'アルゼンチン', 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': 'アルメニア', 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': 'アルバ', 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': 'オーストラリア', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': 'オーストリア', 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': 'アゼルバイジャン', 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': 'バハマ', 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': 'バーレーン', 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': 'バングラデシュ', 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': 'バルバドス', 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': 'ベラルーシ', 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': 'ベルギー', 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': 'ベリーズ', 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': 'ベナン', 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': 'バミューダ', 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': 'ブータン', 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': 'ボリビア', 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': 'ボスニア・ヘルツェゴビナ',
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': 'ボツワナ', 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': 'ブラジル', 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': 'イギリス領インド洋地域', 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': 'イギリス領バージン諸島', 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': 'ブルネイ', 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': 'ブルガリア', 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': 'ブルキナファソ', 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': 'ブルンジ', 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': 'カンボジア', 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': 'カメルーン', 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': 'カナダ', 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': 'カーボベルデ', 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': 'カリブ海 オランダ', 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': 'ケイマン諸島', 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': '中央アフリカ共和国',
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': 'チャド', 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': 'チリ', 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': '中国', 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': 'クリスマス島', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': 'ココス', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': 'コロンビア', 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': 'コモロ', 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': 'コンゴ (DRC)',
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': 'コンゴ（共和国）',
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': 'クック諸島', 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': 'コスタリカ', 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': 'コートジボワール', 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': 'クロアチア', 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': 'キューバ', 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': 'キュラソー', 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': 'キプロス', 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': 'チェコ共和国', 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': 'デンマーク', 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': 'ジブチ', 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': 'ドミニカ', 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': 'ドミニカ共和国',
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': 'エクアドル', 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': 'エジプト', 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': 'エルサルバドル', 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': '赤道ギニア',
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': 'エリトリア', 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': 'エストニア', 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': 'エチオピア', 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': 'フォークランド諸島', 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': 'フェロー諸島', 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': 'フィジー', 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': 'フィンランド', 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': 'フランス', 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': 'フランス領ギアナ', 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': 'フランス領ポリネシア',
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': 'ガボン', 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': 'ガンビア', 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': 'グルジア', 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': 'ドイツ', 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': 'ガーナ', 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': 'ジブラルタル', 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': 'ギリシャ', 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': 'グリーンランド', 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': 'グレナダ', 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': 'グアドループ', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': 'グアム', 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': 'グアテマラ', 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': 'ガーンジー', 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': 'ギニア', 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': 'ギニアビサウ', 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': 'ガイアナ', 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': 'ハイチ', 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': 'ハイチ ホンジュラス', 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': '香港', 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': 'ハンガリー', 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': 'アイスランド', 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': 'インド', 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': 'インドネシア', 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': 'イラン', 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': 'イラク', 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': 'アイルランド', 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': 'マン島', 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': 'イスラエル', 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': 'イタリア', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': 'ジャマイカ', 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': '日本', 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': 'ジャージー', 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': 'ヨルダン', 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': 'カザフスタン', 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': 'ケニアの', 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': 'キリバス', 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': 'コソボ', 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': 'クウェート', 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': 'キルギスタン', 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': 'ラオス', 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': 'ラトビア', 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': 'レバノン', 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': 'レソト', 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': 'リベリア', 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': 'リビア', 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': 'リヒテンシュタイン', 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': 'リトアニア', 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': 'ルクセンブルク', 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': 'マカオ', 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': 'マケドニア', 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': 'マダガスカル', 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': 'マラウイ', 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': 'マレーシア', 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': 'モルディブ', 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': '彼らが持っていた', 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': 'マルタ', 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': 'マーシャル諸島', 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': 'マルティニーク', 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': 'モーリタニア', 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': 'モーリシャス', 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': 'マヨット', 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': 'メキシコ', 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': 'ミクロネシア', 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': 'モルダビア', 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': 'モナコ', 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': 'モンゴル', 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': 'モンテネグロ', 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': 'モントセラト', 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': 'モロッコ', 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': 'モザンビーク', 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': 'ミャンマー', 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': 'ナミビア', 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': 'ナウル', 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': 'ネパール', 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': 'オランダ', 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': 'ニューカレドニア', 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': 'ニュージーランド', 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': 'ニカラグア', 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': 'ニジェール', 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': 'ナイジェリア', 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': 'ニウエ', 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': 'ノーフォーク島', 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': '北朝鮮', 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': '北マリアナ諸島', 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': 'ノルウェー', 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': '自分の', 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': 'パキスタン', 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': 'パラオ', 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': 'パレスチナ', 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': 'パナマ', 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': 'パプアニューギニア', 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': 'パラグアイ', 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': 'ペルー', 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': 'フィリピン', 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': 'ポーランド', 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': 'ポルトガル', 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': 'プエルトリコ', 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': 'カタール', 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': 'ミーティング', 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': 'ルーマニア', 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': 'ロシア', 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': 'ルワンダ', 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': '聖バルテルミー',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': 'セントヘレナ', 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': 'セントキッツ', 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': 'セントルシア', 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': 'セントマーチン',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': 'サンピエール島とミクロン島',
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': 'セントビンセントおよびグレナディーン諸島',
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': 'サモア', 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': 'サンマリノ', 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': 'サントメ・プリンシペ',
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': 'サウジアラビア',
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': 'セネガル', 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': 'セルビア', 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': 'セーシェル', 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': 'シエラレオネ', 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': 'シンガポール', 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': 'セントマーチン', 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': 'スロバキア', 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': 'スロベニア', 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': 'ソロモン', 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': 'ソマリア', 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': '南アフリカ', 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': '韓国', 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': '南スーダン', 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': 'スペイン', 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': 'スリランカ', 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': 'スーダン', 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': 'スリナム', 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `スバールバル諸島とヤンマイエン島`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': 'スワジランド', 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': 'スウェーデン', 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': 'スイス', 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': 'シリア', 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': '台湾', 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': 'タジキスタン', 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': 'タンザニア', 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': 'タンザニア', 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': 'ティモール・リード', 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': 'トーゴ', 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': 'トケラウ', 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `トンガ`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': 'トリニダード・トバゴ', 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': 'チュニジア', 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `トルコ`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': 'トルクメニスタン', 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': 'タークス・カイコス諸島', 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': 'ツバル', 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': 'アメリカ', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': 'イギリス', 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': '米領バージン諸島', 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `ウガンダ`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': 'ウクライナ', 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': 'アラブ首長国連邦',
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': 'ウルグアイ', 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': 'ウズベキスタン', 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': 'バヌアツ', 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': 'バチカン市', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': 'ベネズエラ', 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': 'ベトナム', 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `ウォリスおよびフツナ諸島`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': '西サハラ',
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': 'イエメン', 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': 'ザンビア', 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': 'ジンバブエ', 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': 'オーランド諸島', 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'kor': {
    'af': { 'code': 'af', 'name': '아프가니스탄', 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': '알바니아', 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': '알제리', 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': '미국령 사모아', 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': '안도라', 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': '앙골라', 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': '앵귈라', 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': '앤티가 바부다', 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': '아르헨티나', 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': '아르메니아', 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': '아루바', 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': '호주', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': '오스트리아', 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': '아제르바이잔', 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': '바하마', 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': '바레인', 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': '방글라데시', 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': '바베이도스', 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': '벨라루스', 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': '벨기에', 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': '벨리즈', 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': '베냉', 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': '버뮤다', 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': '부탄', 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': '볼리비아', 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': '보스니아 헤르체고비나',
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': '보츠와나', 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': '브라질', 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': '영국령 인도양 지역', 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': '영국령 버진 아일랜드', 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': '브루나이', 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': '불가리아', 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': '부키 나 파소', 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': '부룬디', 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': '캄보디아', 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': '카메룬', 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': '캐나다', 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': '카보베르데', 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': '캐리비안 네덜란드', 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `케이맨 제도`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': '중앙 아프리카 공화국',
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': '차드', 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': '칠레', 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': '중국', 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': '크리스마스 섬', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': '코코스', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': '콜롬비아', 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': '코모로', 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `콩고(킨샤사)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `콩고 공화국`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': '쿡 제도', 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': '코스타리카', 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': '아이보리 해안', 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `크로아티아`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': '쿠바', 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': '퀴라소', 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `키프로스`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `체코 공화국`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `덴마크`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': '지부티', 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': '도미니카', 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `도미니카 공화국`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': '에콰도르', 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `이집트`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': '엘살바도르', 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `적도 기니`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': '에리트레아', 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `에스토니아`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': '에티오피아', 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `포클랜드 제도(말비나스 제도)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `페로 제도`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': '피지', 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `핀란드`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': '프랑스', 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `프랑스령 기아나`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `프랑스 령 폴리네시아의`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': '가봉', 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': '감비아', 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `그루지야`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `독일`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `가나`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': '지브롤터', 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `그리스`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `그린란드`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': '그레나다', 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': '과들루프', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': '괌', 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': '과테말라', 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': '건지', 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `기니`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `기니비사우`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': '가이아나', 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': '아이티', 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': '온두라스', 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `홍콩`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `헝가리`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `아이슬란드`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `인도`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': '인도네시아', 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `이란`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `이라크`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': '아일랜드', 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': '맨 섬', 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `이스라엘`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `이탈리아`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': '자메이카', 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `일본`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': '저지', 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `요르단`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `카자흐스탄`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': '케냐', 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': '키리바시', 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': '코소보', 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `쿠웨이트`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `키르기스스탄`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `라오스`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `라트비아`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `레바논`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': '레소토', 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': '라이베리아', 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `리비아`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': '리히텐슈타인', 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `리투아니아`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': '룩셈부르크', 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `마카오`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `마케도니아`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `마다가스카르`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': '말라위', 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': '말레이시아', 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': '몰디브', 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': '그들은 가지고 있었다', 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': '몰타', 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': '마셜 제도', 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': '마르티니크', 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `모리타니`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `모리셔스`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': '마요트', 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `멕시코`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': '미크로네시아', 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `몰도바(몰도바 공화국)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': '모나코', 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `몽골리아`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `몬테네그로`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': '몬세라트', 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `모로코`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `모잠비크`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `미얀마`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `나미비아`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': '나우루', 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `네팔`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `네덜란드`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `뉴 칼레도니아`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': '뉴질랜드', 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': '니카라과', 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `니제르`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': '나이지리아', 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': '니우에', 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': '노퍽 섬', 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': '북한(조선 민주주의 인민 공화국)', 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': '북마리아나 제도', 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `노르웨이`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': '오만', 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': '파키스탄', 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': '팔라우', 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': '팔레스타인', 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `파나마`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': '파푸아 뉴기니', 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': '파라과이', 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': '페루', 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': '필리핀 제도', 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': '폴란드', 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': '포르투갈', 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': '푸에르토 리코', 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': '카타르', 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': '회의', 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': '루마니아', 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': '러시아', 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': '르완다', 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': '생바르텔레미',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': '세인트 헬레나', 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': '세인트 키츠 네비스', 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': '세인트 루시아', 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': '세인트 마틴',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': '생 피에르 미클롱',
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': '세인트 빈센트 그레나딘',
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': '사모아', 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': '산 마리노', 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': '상투메 프린시페',
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': '사우디 아라비아',
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': '세네갈', 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': '세르비아', 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': '세이셸', 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': '시에라리온', 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': '싱가포르', 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': '세인트 마틴', 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': '슬로바키아', 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': '슬로베니아', 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': '솔로몬 제도', 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': '소말리아', 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': '남아프리카', 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': '대한민국(대한민국)', 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': '남 수단', 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': '스페인', 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': '스리랑카', 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': '수단', 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': '수리남', 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': '스발바르와 얀마옌', 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': '스와질랜드', 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': '스웨덴', 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': '스위스', 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': '시리아', 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': '대만', 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': '타지키스탄', 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': '탄자니아', 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': '태국', 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': '티모르 읽기', 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': '토고', 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': '토켈라우', 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': '도착했다', 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': '트리니다드 토바고', 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': '튀니지', 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': '칠면조', 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': '투르크메니스탄', 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': '터크스 케이커스 제도', 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': '투발루', 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': '미국', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': '영국', 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': '미국령 버진 아일랜드', 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': '우간다', 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': '우크라이나', 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': '아랍 에미리트',
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': '우루과이', 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': '우즈베키스탄', 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': '바누아투', 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': '바티칸 시국', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': '베네수엘라', 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': '베트남', 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': '월리스와 푸투나', 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': '서부 사하라',
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': '예멘', 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': '잠비아', 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': '짐바브웨', 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': '올란드 제도', 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'de': {
    'af': { 'code': 'af', 'name': `Afghanistan`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `Albanien`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `Algerien`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `Amerikanisch-Samoa`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `Andorra`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `Angola`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `Anguilla`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `Antigua und Barbuda`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `Argentinien`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `Armenien`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `Aruba`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `Australien`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `Österreich`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `Aserbaidschan`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `Bahamas`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `Bahrain`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `Bangladesch`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `Barbados`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `Weißrussland`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `Belgien`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `Belize`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `Benin`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `Bermuda`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `Bhutan`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `Bolivien`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `Bosnien und Herzegowina`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `Botswana`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `Brasilien`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `Britisches Territorium im Indischen Ozean`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `Britische Jungferninseln`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `Brunei`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `Bulgarien`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `Burkina Faso`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `Burundi (Uburundi)`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `Kambodscha`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `Kamerun`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `Kanada`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `Kap Verde`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `Karibik Niederlande`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `Kaimaninseln`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `Zentralafrikanische Republik`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `Chad`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `Chile`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `China`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `Weihnachtsinsel`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `Cocos (Keeling) Inseln`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `Kolumbien`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `Komoren`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `Kongo (DRC)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `Kongo (Republik)`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `Cookinseln`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `Costa Rica`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `Côte d'Ivoire`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `Kroatien (Hrvatska)`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `Kuba`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `Curaçao`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `Zypern`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `Tschechische Republik`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `Dänemark`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `Dschibuti`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `Dominica`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `Dominikanische Republik`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `Ecuador`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `Ägypten`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `El Salvador`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `Äquatorialguinea`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `Eritrea`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `Estland`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `Äthiopien`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `Falklandinseln (Islas Malvinas)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `Färöer Inseln`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `Fidschi`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `Finnland`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `Frankreich`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `Französisch-Guayana`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `Französisch-Polynesien`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `Gabun`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `Gambia`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `Georgien`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `Deutschland`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `Ghana`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `Gibraltar`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `Griechenland`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `Grönland`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `Grenada`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `Guadeloupe`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `Guam`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `Guatemala`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `Guernsey`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `Guinea`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `Guinea-Bissau`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `Guyana`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `Haiti`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `Honduras`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `Hongkong`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `Ungarn`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `Island`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `Indien`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `Indonesien`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `Iran`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `Irak`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `Irland`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `Isle of Man`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `Israel`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `Italien`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `Jamaika`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `Japan`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `Jersey`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `Jordanien`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `Kasachstan`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `Kenia`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `Kiribati`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `Kosovo`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `Kuwait`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `Kirgisistan`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `Laos`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `Lettland`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `Libanon`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `Lesotho`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `Liberia`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `Libyen`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `Liechtenstein`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `Litauen`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `Luxemburg`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `Macau`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `Mazedonien`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `Madagaskar`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `Malawi`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `Malaysia`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `Malediven`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `Mali`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `Malta`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `Marshallinseln`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `Martinique`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `Mauretanien`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `Mauritius (Moris)`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `Mayotte`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `Mexiko`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `Mikronesien`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `Moldawien (Republik Moldau)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `Monaco`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `Mongolei`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `Montenegro`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `Montserrat`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `Marokko`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `Mosambik`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `Myanmar`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `Namibia`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `Nauru`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `Nepal`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `Niederlande`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `Neukaledonien`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `Neuseeland`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `Nicaragua`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `Niger (Nijar)`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `Nigeria`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `Niue`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `Norfolkinsel`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `Nordkorea`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `Nördliche Marianen`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `Norwegen`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `Oman`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `Pakistan`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `Palau`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `Palästina`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `Panama`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `Papua-Neuguinea`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `Paraguay`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `Peru`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `Philippinen`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `Polen`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `Portugal`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `Puerto Rico`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `Katar`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `Insel Réunion`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `Rumänien`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `Russland`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `Ruanda`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `St. Barthelemy's Insel`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `St. Helena`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `St. Kitts und Nevis`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `St. Lucia`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `St. Martins`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `Saint-Pierre und Miquelon`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `St. Vincent und die Grenadinen`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `Samoa`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `San Marino`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `Sao Tome und Principe`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `Saudi-Arabien`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `Senegal`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `Serbien`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `Seychellen`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `Sierra Leone`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `Singapur`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `St. Maarten`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `Slowakei`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `Slowenien`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `Salomoninseln`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `Somalia`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `Südafrika`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `Korea`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `Südsudan`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `Spanien`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `Sri Lanka`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `Sudan`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `Surinam`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `Svalbard und Jan Mayen`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `Swasiland`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `Schweden`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `Schweiz`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `Syrien`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `Taiwan`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `Tadschikistan`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `Tansania`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `Thailand`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `Osttimor`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `Togo`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `Tokelau`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `Tonga`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `Trinidad und Tobago`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `Tunesien`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `Truthähne`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `Turkmenistan`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `Turks- und Caicosinseln`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `Tuvalu`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `Vereinigte Staaten`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `Vereinigtes Königreich`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `Vereinigte Staaten Jungferninseln`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `Uganda`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `Ukraine`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `Vereinigte Arabische Emirate`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `Uruguay`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `Usbekistan`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `Vanuatu`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `Vatikanstadt`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `Venezuela`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `Vietnam`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `Wallis und Futuna Inseln`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `Westsahara`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `Jemen`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `Sambia`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `Simbabwe`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `Åland-Inseln`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'fr': {
    'af': { 'code': 'af', 'name': `Afghanistan`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `Albanie`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `Algérie`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `Samoa américaines`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `Andorre`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `Angola`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `Anguilla`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `Antigua et Barbuda`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `Argentine`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `Arménie`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `Aruba`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `Australie`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `Autriche`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `Azerbaïdjan`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `Bahamas`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `Bahreïn`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `Bangladesh`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `Barbade`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `Bélarus`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `Belgique`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `Belize`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `Bénin`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `Bermudes`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `Bhoutan`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `Bolivie`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `Bosnie-Herzégovine`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `Botswana`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `Brésil`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `Territoire britannique de l'océan Indien`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `Îles Vierges britanniques`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `Brunei`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `Bulgarie`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `Burkina Faso`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `Burundi`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `Cambodge`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `Cameroun`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `Canada`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `Cap-Vert`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `Caraïbes Pays-Bas`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `Îles Caïmans`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `République centrafricaine`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `Chad`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `Chili`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `Chine`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `Île Christmas`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `Îles Cocos (Keeling)`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `Colombie`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `Comores`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `Congo (RDC)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `Congo (République)`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `Îles Cook`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `Costa Rica`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `Ivory Coast`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `Croatie`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `Cuba`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `Curaçao`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `Chypre`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `République tchèque`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `Danemark`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `Djibouti`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `Dominique`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `République dominicaine`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `Équateur`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `Égypte`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `El Salvador`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `Guinée équatoriale`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `Érythrée`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `Estonie`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `Éthiopie`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `Îles Falkland`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `Îles Féroé`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `Fidji`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `Finlande`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `France`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `Guyane française`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `Polynésie française`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `Gabon`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `Gambie`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `Géorgie`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `Allemagne`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `Ghana`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `Gibraltar`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `Grèce`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `Groenland`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `Grenade`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `Guadeloupe`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `Guam`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `Guatemala`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `Guernesey`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `Guinée`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `Guinée-Bissau`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `Guyane`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `Haïti`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `Honduras`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `Hong Kong`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `Hongrie`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `Islande`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `Inde`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `Indonésie`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `Iran`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `Irak`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `Irlande`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `Île de Man`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `Israël`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `Italie`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `Jamaïque`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `Japon`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `Jersey`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `Jordan`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `Kazakhstan`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `Kenya`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `Kiribati`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `Kosovo`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `Koweït`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `Kirghizistan`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `Laos`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `Lettonie`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `Liban`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `Lesotho`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `Liberia`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `Libye`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `Liechtenstein`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `Lituanie`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `Luxembourg`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `Macao`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `Macédoine (FYROM)`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `Madagascar`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `Malawi`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `Malaisie`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `Maldives`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `Mali`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `Malte`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `Îles Marshall`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `Martinique`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `Mauritanie`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `Maurice (Moris)`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `Mayotte`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `Mexique (Mexique)`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `Micronésie`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `Moldavie (République de Moldavie)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `Monaco`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `Mongolie`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `Monténégro`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `Montserrat`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `Maroc`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `Mozambique`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `Myanmar (Birmanie)`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `Namibie`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `Nauru`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `Népal`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `Pays-Bas`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `Nouvelle-Calédonie`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `Nouvelle-Zélande`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `Nicaragua`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `Niger`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `Nigeria`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `Niue`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `Île Norfolk`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `Corée du Nord`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `Îles Mariannes du Nord`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `Norvège`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `Oman`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `Pakistan`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `Palau`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `Palestine`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `Panama`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `Papouasie-Nouvelle-Guinée`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `Paraguay`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `Pérou`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `Philippines`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `Pologne`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `Portugal`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `Porto Rico`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `Qatar`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `Réunion`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `Roumanie`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `Russie`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `Rwanda`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `Saint Barthélemy`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `Sainte-Hélène`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `Saint-Kitts-et-Nevis`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `Sainte-Lucie`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `Saint Martin`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `Saint Pierre et Miquelon`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `Saint-Vincent-et-les-Grenadines`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `Samoa`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `Saint-Marin`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `São Tomé et Príncipe`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `Arabie Saoudite`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `Sénégal`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `Serbie`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `Seychelles`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `Sierra Leone`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `Singapour`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `Sint Maarten`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `Slovaquie`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `Slovénie`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `Îles Salomon`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `Somalie`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `Afrique du Sud`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `Corée du Sud`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `Sud-Soudan`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `Espagne`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `Sri Lanka`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `Soudan`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `Suriname`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `Svalbard et Jan Mayen`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `Swaziland`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `Suède`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `Suisse`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `Syrie`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `Taiwan`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `Tadjikistan`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `Tanzanie`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `Thaïlande`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `Timor-Leste`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `Togo`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `Tokelau`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `Tonga`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `Trinité-et-Tobago`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `Tunisie`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `Turquie`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `Turkménistan`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `Îles Turks et Caicos`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `Tuvalu`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `États-Unis`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `Royaume-Uni`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `Îles Vierges américaines`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `Ouganda`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `Ukraine`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `Émirats arabes unis`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `Uruguay`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `Ouzbékistan`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `Vanuatu`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `Cité du Vatican`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `Venezuela`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `Vietnam`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `Wallis et Futuna`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `Sahara occidental`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `Yémen`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `Zambie`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `Zimbabwe`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `Iles Aland`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'cn': {
    'af': { 'code': 'af', 'name': `阿富汗`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `阿爾巴尼亞`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `阿爾及利亞`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `美屬薩摩亞`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `安道爾`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `安哥拉`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `安圭拉`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `安提瓜和巴布達`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `阿根廷`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `亞美尼亞`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `阿魯巴`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `澳大利亞`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `奧地利`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `阿塞拜疆`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `巴哈馬`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `巴林`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `孟加拉`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `巴巴多斯`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `白俄羅斯`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `比利時`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `伯利茲`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `貝寧`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `百慕大`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `不丹`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `玻利維亞`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `波斯尼亞和黑塞哥維納`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `博茨瓦納`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `巴西`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `英屬印度洋領地`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `英屬維爾京群島`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `文萊`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `保加利亞`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `布基納法索`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `布隆迪`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `柬埔寨`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `喀麥隆`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `加拿大`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `佛得角`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `加勒比海地區 荷蘭`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `開曼群島`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `中非共和國`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `乍得`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `智利`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `中國（大陸）`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `聖誕島`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `科科斯（基林）群島`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `哥倫比亞`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `科摩羅`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `剛果（金）`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `剛果（共和國）`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `庫克群島`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `哥斯達黎加`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `象牙海岸`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `克羅地亞`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `古巴`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `庫拉索島`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `塞浦路斯`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `捷克共和國`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `丹麥`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `吉布提`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `多米尼加`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `多米尼加共和國`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `厄瓜多爾`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `埃及`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `薩爾瓦多`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `赤道幾內亞`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `厄立特里亞`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `愛沙尼亞`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `埃塞俄比亞`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `福克蘭群島(馬爾維納斯群島)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `法羅群島`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `斐濟`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `芬蘭`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `法國`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `法屬圭亞那`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `法屬波利尼西亞`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `加蓬`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `岡比亞`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `喬治亞州`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `德國`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `加納`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `直布羅陀`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `希臘`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `格陵蘭島（卡蘭群島）`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `格林納達`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `瓜德羅普`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `關島`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `危地馬拉`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `格恩西島`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `幾內亞`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `幾內亞比紹`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `圭亞那`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `海地`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `洪都拉斯`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `香港`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `匈牙利`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `冰島`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `印度`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `印度尼西亞`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `伊朗`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `伊拉克`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `愛爾蘭`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `馬恩島`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `以色列`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `意大利`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `牙買加`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `日本`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `澤西島`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `約旦`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `哈薩克斯坦`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `肯尼亞`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `基里巴斯`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `科索沃`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `科威特`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `吉爾吉斯斯坦`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `老撾`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `拉脫維亞`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `黎巴嫩`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `萊索托`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `利比里亞`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `利比亚`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `列支敦士登`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `立陶宛`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `盧森堡`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `澳門`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `馬其頓`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `馬達加斯加`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `馬拉維`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `馬來西亞`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `馬爾代夫`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `馬里`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `馬耳他`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `馬紹爾群島`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `馬提尼克島`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `毛里塔尼亞`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `毛里求斯`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `馬約特島`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `墨西哥`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `密克羅尼西亞`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `摩爾多瓦（摩爾多瓦共和國）`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `摩納哥`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `蒙古國`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `黑山`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `蒙特塞拉特`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `摩洛哥`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `莫桑比克`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `緬甸`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `納米比亞`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `瑙魯`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `尼泊爾`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `荷蘭`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `新喀裡多尼亞`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `新西蘭`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `尼加拉瓜`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `尼日爾`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `尼日利亞`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `紐埃`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `諾福克島`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `北朝鮮`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `北馬里亞納群島`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `挪威`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `阿曼`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `巴基斯坦`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `帕勞`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `巴勒斯坦`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `巴拿馬`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `巴布亞新幾內亞`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `巴拉圭`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `秘魯`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `菲律賓`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `波蘭`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `葡國`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `波多黎各`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `卡塔爾`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `留尼汪`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `罗马尼亚`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `俄罗斯`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `卢旺达`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `圣巴泰勒米`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `圣赫勒拿岛`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `圣基茨和尼维斯`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `圣卢西亚`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `圣马丁（法国部分）`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `圣皮埃尔岛和密克隆岛`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `圣文森特和格林纳丁斯`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `萨摩亚`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `圣马力诺`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `圣多美和普林西比`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `沙特阿拉伯`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `塞内加尔`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `塞尔维亚`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `塞舌尔`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `塞拉里昂`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `新加坡`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `圣马丁`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `斯洛伐克`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `斯洛文尼亞`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `所羅門群島`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `索馬里`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `南非`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `南韓`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `南蘇丹`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `西班牙`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `斯里蘭卡`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `蘇丹`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `蘇里南`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `斯瓦爾巴群島和揚馬延島`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `斯威士蘭`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `瑞典`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `瑞士`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `敘利亞`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `台灣`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `塔吉克斯坦`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `坦桑尼亞`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `泰國`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `東帝汶`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `多哥`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `托克勞群島`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `湯加`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `特立尼達和多巴哥`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `突尼斯`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `土耳其`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `土庫曼斯坦`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `特克斯和凱科斯群島`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `圖瓦盧`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `美國`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `英國`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `美屬維爾京群島`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `烏干達`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `烏克蘭`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `阿拉伯聯合酋長國`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `烏拉圭`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `烏茲別克斯坦`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `瓦努阿圖`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `梵蒂岡城`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `委內瑞拉`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `越南`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `瓦利斯和富圖納`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `西撒哈拉`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `也門`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `贊比亞`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `津巴布韋`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `奧蘭群島`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'zh': {
    'af': { 'code': 'af', 'name': `阿富汗`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `阿尔巴尼亚`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `阿尔及利亚`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `美属萨摩亚`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `安道尔`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `安哥拉`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `安圭拉`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `安提瓜和巴布达`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `阿根廷`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `亚美尼亚`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `阿鲁巴`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `澳大利亚`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `奥地利`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `阿塞拜疆`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `巴哈马`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `巴林`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `孟加拉`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `巴巴多斯`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `白俄罗斯`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `比利时`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `伯利兹`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `贝宁`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `百慕大`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `不丹`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `玻利维亚`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `波斯尼亚和黑塞哥维纳`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `博茨瓦纳`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `巴西`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `英属印度洋领地`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `英属维尔京群岛`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `文莱`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `保加利亚`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `布基纳法索`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `布隆迪`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `柬埔寨`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `喀麦隆`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `加拿大`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `佛得角`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `加勒比海地区 荷兰`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `开曼群岛`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `中非共和国`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `乍得`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `智利`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `中国（大陆）`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `圣诞岛`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `科科斯（基林）群岛`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `哥伦比亚`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `科摩罗`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `刚果（金）`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `刚果（共和国）`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `库克群岛`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `哥斯达黎加`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `象牙海岸`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `克罗地亚`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `古巴`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `库拉索岛`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `塞浦路斯`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `捷克共和国`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `丹麦`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `吉布提`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `多米尼加`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `多米尼加共和国`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `厄瓜多尔`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `埃及`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `萨尔瓦多`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `赤道几内亚`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `厄立特里亚`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `爱沙尼亚`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `埃塞俄比亚`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `福克兰群岛(马尔维纳斯群岛)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `法罗群岛`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `斐济`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `芬兰`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `法国`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `法属圭亚那`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `法属波利尼西亚`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `加蓬`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `冈比亚`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `乔治亚州`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `德国`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `加纳`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `直布罗陀`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `希腊`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `格陵兰岛（卡兰群岛）`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `格林纳达`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `瓜德罗普`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `关岛`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `危地马拉`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `格恩西岛`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `几内亚`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `几内亚比绍`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `圭亚那`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `海地`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `洪都拉斯`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `香港`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `匈牙利`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `冰岛`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `印度`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `印度尼西亚`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `伊朗`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `伊拉克`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `爱尔兰`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `马恩岛`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `以色列`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `意大利`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `牙买加`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `日本`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `泽西岛`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `约旦`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `哈萨克斯坦`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `肯尼亚`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `基里巴斯`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `科索沃`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `科威特`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `吉尔吉斯斯坦`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `老挝`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `拉脱维亚`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `黎巴嫩`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `莱索托`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `利比里亚`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `利比亚`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `列支敦士登`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `立陶宛`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `卢森堡`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `澳门`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `马其顿`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `马达加斯加`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `马拉维`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `马来西亚`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `马尔代夫`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `马里`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `马耳他`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `马绍尔群岛`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `马提尼克岛`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `毛里塔尼亚`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `毛里求斯`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `马约特岛`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `墨西哥`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `密克罗尼西亚`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `摩尔多瓦（摩尔多瓦共和国）`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `摩纳哥`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `蒙古国`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `黑山`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `蒙特塞拉特`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `摩洛哥`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `莫桑比克`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `缅甸`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `纳米比亚`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `瑙鲁`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `尼泊尔`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `荷兰`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `新喀里多尼亚`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `新西兰`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `尼加拉瓜`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `尼日尔`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `尼日利亚`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `纽埃`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `诺福克岛`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `北朝鲜`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `北马里亚纳群岛`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `挪威`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `阿曼`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `巴基斯坦`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `帕劳`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `巴勒斯坦`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `巴拿马`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `巴布亚新几内亚`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `巴拉圭`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `秘鲁`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `菲律宾`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `波兰`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `葡国`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `波多黎各`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `卡塔尔`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `留尼汪`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `罗马尼亚`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `俄罗斯`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `卢旺达`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `圣巴泰勒米`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `圣赫勒拿岛`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `圣基茨和尼维斯`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `圣卢西亚`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `圣马丁（法国部分）`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `圣皮埃尔岛和密克隆岛`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `圣文森特和格林纳丁斯`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `萨摩亚`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `圣马力诺`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `圣多美和普林西比`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `沙特阿拉伯`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `塞内加尔`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `塞尔维亚`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `塞舌尔`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `塞拉里昂`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `新加坡`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `圣马丁`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `斯洛伐克`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `斯洛文尼亚`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `所罗门群岛`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `索马里`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `南非`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `南韩`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `南苏丹`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `西班牙`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `斯里兰卡`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `苏丹`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `苏里南`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `斯瓦尔巴群岛和扬马延岛`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `斯威士兰`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `瑞典`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `瑞士`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `叙利亚`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `台湾`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `塔吉克斯坦`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `坦桑尼亚`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `泰国`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `东帝汶`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `多哥`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `托克劳群岛`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `汤加`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `特立尼达和多巴哥`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `突尼斯`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `土耳其`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `土库曼斯坦`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `特克斯和凯科斯群岛`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `图瓦卢`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `美国`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `英国`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `美属维尔京群岛`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `乌干达`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `乌克兰`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `阿拉伯联合酋长国`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `乌拉圭`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `乌兹别克斯坦`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `瓦努阿图`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `梵蒂冈城`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `委内瑞拉`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `越南`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `瓦利斯和富图纳`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `西撒哈拉`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `也门`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `赞比亚`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `津巴布韦`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `奥兰群岛`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'th': {
    'af': { 'code': 'af', 'name': 'อัฟกานิสถาน', 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': 'แอลเบเนีย', 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': 'แอลจีเรีย ', 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': 'อเมริกันซามัว', 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': 'อันดอร์รา', 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': 'แองโกลา', 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': 'แองกวิลลา', 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': 'แอนติกาและบาร์บูดา', 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': 'อาร์เจนตินา', 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': 'อาร์เมเนีย', 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': 'อารูบา', 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': 'ออสเตรเลีย', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': 'ออสเตรีย', 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': 'อาเซอร์ไบจาน', 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': 'บาฮามาส', 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': 'บาห์เรน ', 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': 'บังกลาเทศ ', 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': 'บาร์เบโดส', 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': 'เบลารุส', 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': 'เบลเยี่ยม', 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': 'เบลีซ', 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': 'เบนิน', 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': 'เบอร์มิวดา', 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': 'ภูฏาน', 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': 'โบลิเวีย', 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': 'บอสเนียและเฮอร์เซโก ',
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': 'บอตสวานา', 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': 'บราซิล', 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': 'อังกฤษ ดินแดนมหาสมุทรอินเดีย', 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': 'หมู่เกาะบริติชเวอร์จิน', 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': 'บรูไน', 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': 'บัลแกเรีย', 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': 'บูร์กินาฟาโซ', 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': 'บุรุนดี', 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': 'กัมพูชา (កម្ពុជា)', 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': 'แคเมอรูน', 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': 'แคนาดา', 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': 'เคปเวิร์ด', 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': 'แคริบเบียน เนเธอร์แลนด์', 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': 'หมู่เกาะเคย์แมน', 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': 'สาธารณรัฐแอฟริกากลาง ',
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': 'ชาด', 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': 'ชิลี', 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': 'จีน ', 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': 'เกาะคริสต์มาส', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': 'โคโคส (คีลิง) หมู่เกาะ', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': 'โคลอมเบีย', 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': 'คอโมโรส', 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': 'คองโก (ดร) (สาธารณรัฐประชาธิปไตยคองโก)',
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': 'คองโก(สาธารณรัฐ) (คองโก-บราซซาวิล)',
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': 'หมู่เกาะคุก', 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': 'คอสตาริกา', 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': 'ไอวอรี่โคสต์', 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': 'โครเอเชีย (ฮวัตสกา)', 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': 'คิวบา', 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': 'คูราเซา', 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': 'ไซปรัส ', 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': 'สาธารณรัฐเช็ก', 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': 'เดนมาร์ก', 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': 'จิบูตี', 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': 'โดมินิกา', 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': 'สาธารณรัฐโดมินิกัน',
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': 'เอกวาดอร์', 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': 'อียิปต์', 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': 'เอลซัลวาดอร์', 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': 'อิเควทอเรียลกินี',
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': 'เอริเทรีย', 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': 'เอสโตเนีย', 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': 'เอธิโอเปีย', 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': 'หมู่เกาะฟอล์คแลนด์', 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': 'หมู่เกาะแฟโร', 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': 'ฟิจิ', 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': 'ฟินแลนด์', 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': 'ฝรั่งเศส', 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': 'เฟรนช์เกีย', 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': 'เฟรนช์โปลินีเซีย',
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': 'กาบอง', 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': 'แกมเบีย', 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': 'จอร์เจีย', 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': 'เยอรมนี', 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': 'กานา', 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': 'ยิบรอลตาร์', 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': 'กรีซ', 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': 'กรีนแลนด์', 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': 'เกรนาดา', 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': 'กวาเดอลูป', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': 'กวม', 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': 'กัวเตมาลา', 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': 'เกิร์นซีย์', 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': 'กินี', 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': 'กินีบิสเซา', 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': 'กายอานา', 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': 'เฮติ', 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': 'ฮอนดูรัส', 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': 'ฮ่องกง', 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': 'ฮังการี', 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': 'ไอซ์แลนด์', 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': 'อินเดีย', 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': 'อินโดนีเซีย', 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': 'อิหร่าน', 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': 'อิรัก', 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': 'ไอร์แลนด์', 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': 'เกาะแมน', 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': 'อิสราเอล', 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': 'อิตาลี', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': 'จาเมกา', 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': 'ญี่ปุ่น', 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': 'เจอร์ซีย์', 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': 'จอร์แดน ', 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': 'คาซัคสถาน', 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': 'เคนยา', 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': 'คิริบาส', 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': 'โคโซโว', 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': 'คูเวต', 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': 'คีร์กีซสถาน', 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': 'ลาว', 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': 'ลัตเวีย', 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': 'เลบานอน', 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': 'เลโซโท', 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': 'ประเทศไลบีเรีย', 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': 'ลิเบีย', 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': 'ลิกเตนสไตน์', 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': 'ลิทัวเนีย', 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': 'ลักเซมเบิร์ก', 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': 'มาเก๊า', 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': 'มาซิโดเนีย (ฟิรอม)', 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': 'มาดากัสการ์', 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': 'มาลาวี', 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': 'มาเลเซีย', 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': 'มัลดีฟส์', 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': 'พวกเขามี', 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': 'มอลตา', 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': 'หมู่เกาะมาร์แชลล์', 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': 'มาร์ตินีก', 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': 'มอริเตเนีย', 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': 'มอริเชียส', 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': 'มายอต', 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': 'เม็กซิโก', 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': 'ไมโครนีเซีย', 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': 'มอลโดเวีย', 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': 'โมนาโก', 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': 'มองโกเลีย', 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': 'มอนเตเนโกร', 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': 'มอนต์เซอร์รัต', 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': 'โมร็อกโก', 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': 'โมซัมบิก', 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': 'พม่า', 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': 'นามิเบีย', 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': 'นาอูรู', 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': 'เนปาล', 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': 'เนเธอร์แลนด์', 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': 'นิวแคลิโดเนีย', 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': 'นิวซีแลนด์', 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': 'นิการากัว', 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': 'ไนเจอร์', 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': 'ไนจีเรีย', 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': 'นีอูเอ', 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': 'เกาะนอร์ฟอล์ก', 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': 'เกาหลีเหนือ', 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': 'หมู่เกาะนอร์เทิร์นมาเรียนา', 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': 'นอร์เวย์', 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': 'ของฉันเอง', 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': 'ปากีสถาน', 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': 'ปาเลา', 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': 'ปาเลสไตน์', 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': 'ปานามา', 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': 'ปาปัวนิวกินี', 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': 'ประเทศปารากวัย', 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': 'เปรู', 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': 'ฟิลิปปินส์', 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': 'โปแลนด์ ', 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': 'โปรตุเกส', 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': 'เปอร์โตริโก้', 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': 'กาตาร์', 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': 'การประชุม', 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': 'โรมาเนีย', 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': 'รัสเซีย', 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': 'รวันดา', 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': 'นักบุญบาร์เธเลมี',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': 'เซนต์เฮเลน่า', 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': 'เซนต์คิตส์และเนวิส', 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': 'เซนต์ลูเซีย', 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': 'เซนต์มาร์ติน (แซงต์-มาร์แต็ง (ส่วนภาษาฝรั่งเศส))',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': 'แซงปีแยร์และมีเกอลง',
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': 'เซนต์วินเซนต์และเกรนาดีนส์',
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': 'ซามัว', 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': 'ซานมาริโน', 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': 'เซาตูเมและหลักการ',
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': 'ซาอุดิอาราเบีย',
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': 'เซเนกัล', 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': 'เซอร์เบีย', 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': 'เซเชลส์', 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': 'เซียร์ราลีโอน', 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': 'สิงคโปร์', 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': 'เซนต์มาร์ติน', 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': 'สโลวาเกีย', 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': 'สโลวีเนีย', 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': 'หมู่เกาะโซโลมอน', 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': 'โซมาเลีย', 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': 'แอฟริกาใต้', 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': 'เกาหลีใต้', 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': 'ซูดานใต้', 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': 'สเปน', 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': 'ศรีลังกา', 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': 'ซูดาน', 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': 'ซูรินาเม', 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': 'สวาลบาร์ดและยานไมเอน', 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': 'สวาซิแลนด์', 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': 'สวีเดน', 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': 'สวิตเซอร์แลนด์', 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': 'ซีเรีย', 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': 'ไต้หวัน', 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': 'ทาจิกิสถาน', 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': 'แทนซาเนีย', 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': 'ประเทศไทย', 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': 'ติมอร์อ่าน', 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': 'ไป', 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': 'โตเกเลา', 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': 'มาถึงแล้ว', 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': 'ตรินิแดดและโตเบโก', 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': 'ตูนิเซีย', 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': 'ไก่งวง', 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': 'เติร์กเมนิสถาน', 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': 'หมู่เกาะเติกส์และหมู่เกาะเคคอส', 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': 'ตูวาลู', 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': 'สหรัฐ', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': 'ประเทศอังกฤษ', 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': 'หมู่เกาะเวอร์จินของสหรัฐอเมริกา', 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': 'ยูกันดา', 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': 'ยูเครน', 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': 'สหรัฐอาหรับเอมิเรตส์',
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': 'อุรุกวัย', 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': 'อุซเบกิสถาน', 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': 'วานูอาตู', 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': 'เมืองวาติกัน', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': 'เวเนซุเอลา', 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': 'เวียดนาม', 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': 'วาลลิสและฟุตูนา', 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': 'ซาฮาร่าตะวันตก',
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': 'เยเมน', 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': 'แซมเบีย', 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': 'ซิมบับเว', 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': 'หมู่เกาะโอลันด์', 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'es': {
    'af': { 'code': 'af', 'name': 'Afganistán', 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': 'Albania', 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': 'Argelia', 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': 'Samoa Americana', 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': 'Andorra', 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': 'Angola', 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': 'Anguilla', 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': 'Antigua y Barbuda', 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': 'Argentina', 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': 'Armenia', 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': 'Aruba', 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': 'Australia', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': 'Austria', 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': 'Azerbaiyán', 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': 'Bahamas', 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': 'Baréin', 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': 'Bangladesh', 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': 'Barbados', 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': 'Bielorrusia', 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': 'Bélgica', 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': 'Belice', 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': 'Benín', 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': 'islas Bermudas', 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': 'Bután', 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': 'Bolivia', 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': 'Bosnia y Herzegovina',
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': 'Botsuano', 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': 'Brasil', 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': 'Territorio Británico del Océano Índico', 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': 'Islas Vírgenes Británicas', 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': 'Brunéi', 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': 'Bulgaria', 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': 'Burkina Faso', 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': 'Burundi', 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': 'Camboya', 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': 'Camerún', 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': 'Canada', 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': 'Cabo Verde', 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': 'Caribe neerlandés', 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': 'Islas Caimán', 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': 'República Centroafricana',
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': 'Chad', 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': 'Chile', 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': 'Porcelana', 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': 'Isla de Navidad', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': 'Cocos (Keeling) Islas', 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': 'Colombia', 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': 'Comoras', 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': 'Congo (República Democrática del Congo)',
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': 'Congo (República) (Congo-Brazzaville)',
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': 'Islas Cook', 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': 'Costa Rica', 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': 'Costa de Marfil', 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': 'Croacia', 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': 'Cuba', 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': 'curazao', 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': 'Chipre', 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': 'Republica checa', 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': 'Dinamarca', 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': 'Yibuti', 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': 'Dominica', 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': 'República Dominicana',
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': 'Ecuador', 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': 'Egipto', 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': 'El Salvador', 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': 'Guinea Ecuatorial',
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': 'Eritrea', 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': 'Estonia', 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': 'Etiopía', 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': 'Islas Malvinas', 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': 'Islas Faroe', 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': 'Fiyi', 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': 'Finlandia', 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': 'Francia', 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': 'Guayana Francesa', 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': 'Polinesia francés',
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': 'Gabón', 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': 'Gambia', 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': 'Georgia', 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': 'Alemania', 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': 'Ghana', 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': 'Gibraltar', 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': 'Grecia', 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': 'Groenlandia', 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': 'Grenada', 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': 'Guadalupe', 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': 'Guam', 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': 'Guatemala', 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': 'Guernsey', 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': 'Guinea', 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': 'Guinea-Bisáu', 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': 'Guayana', 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': 'Haití', 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': 'Honduras', 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': 'Hong Kong', 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': 'Hungría', 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': 'Islandia', 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': 'India', 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': 'Indonesia', 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': 'Irán', 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': 'Irak', 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': 'Irlanda', 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': 'Isla del hombre', 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': 'Israel', 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': 'Italia', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': 'Jamaica', 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': 'Japón', 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': 'Jersey', 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': 'Jordán', 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': 'Kazajstán', 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': 'Kenia', 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': 'Kiribati', 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': 'Kosovo', 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': 'Kuwait', 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': 'Kirguistán', 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': 'Laos', 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': 'letonia', 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': 'Líbano', 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': 'Lesoto', 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': 'Liberia', 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': 'Libia', 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': 'Liechtenstein', 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': 'Lituania', 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': 'luxemburgo', 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': 'Macao', 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': 'Macedonia (FYROM) (Македонија)', 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': 'Madagascar', 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': 'Malawi', 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': 'Malasia', 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': 'Maldivas', 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': 'Tuvieron', 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': 'Malta', 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': 'Islas Marshall', 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': 'Martinica', 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': 'Mauritania', 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': 'Mauricio (Moris)', 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': 'Mayotte', 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': 'México', 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': 'Micronesia', 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': 'Moldavia', 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': 'Mónaco', 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': 'Mongolia', 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': 'Montenegro', 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': 'Montserrat', 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': 'Marruecos', 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': 'Mozambique', 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': 'Birmania', 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': 'Namibia', 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': 'Nauru', 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': 'Nepal', 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': 'Países Bajos', 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': 'Nueva Caledonia', 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': 'Nueva Zelanda', 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': 'Nicaragua', 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': 'Níger', 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': 'Nigeria', 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': 'Niue', 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': 'Isla Norfolk', 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': 'Corea del Norte', 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': 'Islas Marianas del Norte', 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': 'Noruega', 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': 'Mío', 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': 'Pakistán', 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': 'Palau', 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': 'Palestino', 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': 'Panamá', 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': 'Papúa Nueva Guinea', 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': 'Paraguay', 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': 'Perú', 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': 'Filipinas', 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': 'Polonia', 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': 'Portugal', 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': 'Puerto Rico', 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': 'Katar', 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': 'Cita', 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': 'Rumania', 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': 'Rusia', 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': 'Ruanda', 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': 'San Bartolomé',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': 'Santa Elena', 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': 'San Cristóbal y Nieves', 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': 'Saint Lucia', 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': 'San Martín',
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': 'San Pedro y Miquelón',
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': 'San Vicente y las Granadinas',
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': 'Samoa', 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': 'San Marino', 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': 'Santo Tomé y Príncipe',
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': 'Arabia Saudita',
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': 'Senegal', 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': 'Serbia', 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': 'Seychelles', 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': 'Sierra Leona', 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': 'Singapur', 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': 'San Martín', 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': 'Eslovaquia', 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': 'Eslovenia', 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': 'Islas Salomón', 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': 'Somalia', 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': 'Sudáfrica', 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': 'Corea del Sur', 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': 'Sudán del Sur', 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': 'España', 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': 'Sri Lanka', 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': 'Sudán', 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': 'Surinam', 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': 'Svalbard y Jan Mayen', 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': 'Suazilandia', 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': 'Suecia', 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': 'Suiza', 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': 'Siria', 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': 'Taiwán', 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': 'Tayikistán', 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': 'Tanzania', 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': 'Tailandia', 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': 'Timor leyó', 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': 'Para llevar', 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': 'Tokelau', 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': 'Llegó', 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': 'Trinidad y Tobago', 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': 'Túnez', 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': 'Pavo', 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': 'turkmenistán', 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': 'Islas Turcas y Caicos', 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': 'Tuvalu', 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': 'Estados Unidos', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': 'Reino Unido', 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': 'Islas Vírgenes de EE.UU', 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': 'Uganda', 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': 'Ucrania', 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': 'Emiratos Árabes Unidos',
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': 'Uruguay', 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': 'Uzbekistán', 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': 'Vanuatu', 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': 'Ciudad del Vaticano', 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': 'Venezuela', 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': 'Vietnam', 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': 'Wallis y Futuna', 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': 'Sahara Occidental',
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': 'Yemen', 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': 'Zambia', 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': 'Zimbabue', 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': 'Islas Aland', 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'india': {
    'af': { 'code': 'af', 'name': `Afganistan`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `Albania`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `Aljazair`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `Samoa Amerika`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `Andorra`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `Angola`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `Anguila`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `Antigua dan Barbuda`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `Argentina`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `Armenia`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `Aruba`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `Australia`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `Austria`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `Azerbaijan`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `Bahama`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `Bahrain`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `Benggala`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `Barbados`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `Belarusia`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `Belgium`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `Belize`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `Benin`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `Bermuda`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `Bhutan`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `Bolivia`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `Bosnia dan Herzegovina`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `Botswana`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `Brazil`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `Wilayah Samudra Hindia Inggris`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `Kepulauan Virgin Inggris`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `Brunei`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `Bulgaria`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `Burkina Faso`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `Burundi`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `Kamboja`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `Kamerun`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `Kanada`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `tanjung verde`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `Karibia Belanda`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `Pulau cayman`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `Republik Afrika Tengah`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `Chad`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `Chili`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `Cina`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `Pulau Natal`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `Kepulauan Cocos (Keeling).`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `Kolumbia`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `Komoro`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `Kongo (Kinshasa)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `Republik Kongo)`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `Pulau`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `Kosta Rika`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `Pantai Gading`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `Kroasia`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `Kuba`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `Curacao`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `Siprus`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `Republik Ceko`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `Denmark`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `Djibouti`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `Dominika`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `Republik Dominika`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `Ekuador`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `Mesir`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `El Salvador`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `Guinea ekuator`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `Eritrea`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `Estonia`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `Etiopia`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `Kepulauan Falkland (Kepulauan Malvinas)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `Kepulauan Faroe`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `Fiji`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `Finlandia`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `Perancis`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `Guyana Perancis`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `Polinesia Perancis`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `Gabon`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `Gambia`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `Georgia`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `Jerman`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `Ghana`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `Gibraltar`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `Yunani`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `Greenland (Kepulauan Kalan)`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `Granat`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `Guadeloupe`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `Guam`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `Guatemala`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `Guernsey`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `Guinea`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `Guinea-Bissau`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `Guyana`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `Haiti`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `Honduras`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `Hongkong`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `Hungaria`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `Islandia`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `India`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `Indonesia`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `Iran`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `Irak`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `Irlandia`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `Pulau manusia`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `Israel`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `Italia`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `Jamaika`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `Jepang`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `Jersey`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `Yordania`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `Kazakstan`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `Kenya`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `Kiribati`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `Kosovo`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `Kuwait`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `Kyrgyzstan`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `Laos`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `Latvia`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `Libanon`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `Lesotho`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `Liberia`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `Libya`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `Liechtenstein`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `Lithuania`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `Luksemburg`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `Makau`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `Makedonia`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `Madagaskar`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `Malawi`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `Malaysia`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `Maladewa`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `Mali`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `Malta`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `Pulau Marshall`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `Martinik`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `Mauritania`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `Mauritius`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `Mayotte`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `Meksiko`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `Mikronesia`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `Moldova (Republik Moldova)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `Monako`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `Mongolia`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `Montenegro`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `Montserrat`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `Maroko`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `Mozambik`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `Myanmar`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `Namibia`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `Namibia`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `Nepal`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `Belanda`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `Kaledonia Baru`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `Selandia Baru`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `Nikaragua`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `Niger`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `Nigeria`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `Niue`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `Pulau norfolk`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `Korea Utara`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `Kepulauan Mariana Utara`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `Norway`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `Oman`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `Pakistan`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `Palau`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `Palestina`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `Panama`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `Papua Nugini`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `Paraguay`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `Peru`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `Orang Filipina`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `Polandia`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `Portugal`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `Puerto riko`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `Qatar`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `Reuni`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `Rumania`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `Rusia`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `Rwanda`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `Saint barthelemy`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `St Helena`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `Saint Kitts dan Nevis`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `Santo lucia`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `Saint Martin (bagian Prancis)`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `Saint Pierre dan Miquelon`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `Saint Vincent dan Grenadines`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `Samoa`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `San marino`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `Sao tome dan prinsip`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `Arab Saudi`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `Senegal`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `Serbia`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `Seychelles`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `Sierra Leone`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `Singapura`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `Santo martin`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `Slowakia`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `Slovenia`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `Pulau Solomon`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `Somalia`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `Afrika Selatan`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `Korea Selatan`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `Sudan Selatan`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `Spanyol`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `Srilanka`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `Sudan`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `Suriname`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `Svalbard dan Jan Mayen`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `Swaziland`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `Swedia`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `Swiss`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `Suriah`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `Taiwan`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `Tajikistan`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `Tanzania`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `Thailand`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `Timor Timur`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `Untuk pergi`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `Pulau tokelau`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `Tonga`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `Trinidad dan Tobago`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `Tunisia`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `Turki`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `Turkmenistan`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `Kepulauan Turks dan Caicos`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `Tuvalu`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `Amerika Serikat`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `Inggris Raya`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `Kepulauan Virgin Amerika Serikat`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `Uganda`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `Ukraina`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `Uni Emirat Arab`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `Uruguay`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `Uzbekistan`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `Vanuatu`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `Kota Vatikan`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `Venezuela`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `Vietnam`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `Wallis dan futuna`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `Sahara Barat`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `Yaman`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `Zambia`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `Zimbabwe`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `Pulau Aland`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'ar': {
    'af': { 'code': 'af', 'name': `أفغانستان`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `ألبانيا`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `الجزائر`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `ساموا`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `أندورا`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `أنغولا`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `أنغيلا`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `أنتيغوا`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `الأرجنتين`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `أرمينيا`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `أروبا`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `أستراليا`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `النمسا`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `أذربيجان`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `البهاما`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `البحرين`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `البحرين`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `بربادوس`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `بيلاروس`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `بلجيكا`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `بليز`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `بنن`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `برمودا`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `بوتان`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `بوليفيا`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `البوسنة والهرسك (البوسنة والهرسك)`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `بوتسوانا`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `البرازيل`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `إقليم المحيط البريطاني الهندي`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `جزر فيرجن البريطانية`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `بروناي`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `بلغاريا`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `بوركينا فاسو`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `بوروندي`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `كمبوديا`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `الكاميرون`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `كندا`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `الرأس الأخضر`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `هولندا الكاريبية`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `جزر كايمان`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `جمهورية افريقيا الوسطى`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `تشاد`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `تشيلي`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `البر الرئيسي الصيني)`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `جزيرة الكريسماس`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `جزر كوكوس (كيلينغ)`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `كولومبيا`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `جزر القمر`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `الكونغو (كينشاسا)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `جمهورية الكونغو)`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `جزيرة`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `كوستا ريكا`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `ساحل العاج`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `كرواتيا`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `كوبا`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `كوراكاو`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `قبرص`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `الجمهورية التشيكية`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `الدنمارك`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `جيبوتي`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `دومينيكا`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': `جمهورية الدومينيكان`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `الاكوادور`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `مصر`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `السلفادور`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `赤道几内亚`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `إريتريا`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `إستونيا`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `أثيوبيا`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `جزر فوكلاند (جزر مالفيناس)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `جزر فاروس`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `فيجي`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `فنلندا`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `فرنسا`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `غيانا الفرنسية`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `بولينيزيا الفرنسية`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `الجابون`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `غامبيا`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `جورجيا`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `ألمانيا`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `غانا`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `جبل طارق`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `اليونان`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `جرينلاند (جزر كالان)`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `غرينادا`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `جوادلوب`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `غوام`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `غواتيمالا`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `غيرنسي`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `غينيا`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `غينيا بيساو`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `غيانا`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `هايتي`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `هندوراس`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `هونغ كونغ`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `هنغاريا`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `أيسلندا`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `الهند`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `إندونيسيا`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `إيران`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `العراق`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `أيرلندا`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `جزيرة آيل أوف مان`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `إسرائيل`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `إيطاليا`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `جامايكا`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `اليابان`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `جيرسي`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `الأردن`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `كازاخستان`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `كينيا`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `كيريباتي`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `كيريباتي`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `الكويت`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `قيرغيزستان`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `لاوس`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `لاتفيا`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `لبنان`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `ليسوتو`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `ليبيريا`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `ليبيا`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `ليبيا`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `ليتوانيا`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `لوكسمبورغ`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `ماكاو`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `مقدونيا`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `مدغشقر`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `ملاوي`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `ماليزيا`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `جزر المالديف`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `مالي`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `مالطا`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `جزر مارشال`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `مارتينيك`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `موريتانيا`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `موريشيوس`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `مايوت`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `المكسيك`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `ميكرونيزيا`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `مولدوفا (جمهورية مولدوفا)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `موناكو`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `منغوليا`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `الجبل الأسود`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `مونتسيرات`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `المغرب`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `موزمبيق`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `ميانمار`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `ناميبيا`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `ناورو`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `نيبال`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `هولندا`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `كاليدونيا الجديدة`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `نيوزيلندا`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `نيكاراغوا`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `النيجر`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `نيجيريا`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `نيوي`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `جزيرة نورفولك`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `كوريا الشمالية`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `كوريا الشمالية`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `النرويج`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `سلطنة عمان`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `باكستان`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `بالاو`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `فلسطين`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `بنما`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `بابوا غينيا الجديدة`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `باراغواي`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `بيرو`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `الفلبينيين`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `بولندا`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `البرتغال`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `بورتوريكو`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `دولة قطر`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `جمع شمل`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `رومانيا`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `روسيا`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `رواندا`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `سانت بارتيليمي`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `سانت هيلانة`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `سانت كيتس ونيفيس`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `القديسة لوسيا`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `سانت مارتن (الجزء الفرنسي)`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `سانت بيير وميكلون`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `سانت فنسنت وجزر غرينادين`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `ساموا`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `سان مارينو`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `ساو تومي وبرينسيبي`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `المملكة العربية السعودية`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `السنغال`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `صربيا`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `سيشيل`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `سيرا ليون`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `سنغافورة`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `القديس مارتن`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `سلوفاكيا`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `سلوفينيا`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `جزر سليمان`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `الصومال`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `جنوب أفريقيا`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `كوريا الجنوبية`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `جنوب السودان`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `إسبانيا`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `سيريلانكا`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `السودان`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `سورينام`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `سفالبارد وجان ماين`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `سوازيلاند`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `السويد`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `سويسرا`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `سوريا`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `تايوان`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `طاجيكستان`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `تنزانيا`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `تايلاند`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `تيمور الشرقية`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `توجو`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `جزر توكيلاو`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `تونغا`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `ترينداد وتوباغو`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `تونس`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `تركيا`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `تركمانستان`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `جزر تركس وكايكوس`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `توفالو`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `نحن.`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `المملكة المتحدة.`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `جزر فيرجن التابعة للولايات المتحدة`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `أوغندا`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `أوكرانيا`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `الإمارات العربية المتحدة`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `أوروغواي`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `أوزبكستان`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `فانواتو`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `مدينة الفاتيكان`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `فنزويلا`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `فيتنام`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `واليس وفوتونا`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `الصحراء الغربية`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `اليمن`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `زامبيا`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `زيمبابوي`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `جزر آلاند`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'vi': {
    'af': { 'code': 'af', 'name': `Afghanistan`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `Albania`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `Algeria`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `American Samoa`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `Andor`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `Angola`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `Anguilla`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `Antigua và Barbuda`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `Argentina`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `Armenia`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `Aruba`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `Australia`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `Austria`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `Azerbaijan`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `Bahamas`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `Bahrain`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `Bangladesh`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `Barbados`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'bởi': { 'code': 'by', 'name': `Belarus`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `Belgium`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `Belize`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `Benin`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `Bermuda`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `Bhutan`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `Bolivia`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `Bosnia và Herzegovina`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `Botswana`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `Brazil`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `Lãnh thổ Ấn Độ Dương thuộc Anh`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `Quần đảo Virgin thuộc Anh`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `Brunei`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `Bulgaria`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `Burkina Faso`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `Burundi`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `Campuchia`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `Cameroon`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `Canada`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `Cape Verde`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `Caribe Hà Lan`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `Cayman Islands`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `Cộng hòa Trung Phi`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `Chad`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `Chile`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `Trung Quốc (đại lục)`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `Christmas Island`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `Cocos (Keeling) Islands`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `Colombia`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `Comores`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `Congo (Kinshasa)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `Congo (Cộng hòa)`,
      'dialCode': 242,
      'Định dạng điện thoại': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `Cook Islands`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `Costa Rica`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `Ivory Coast`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `Croatia`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `Cuba`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `Curacao`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `Cyprus`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `Cộng hòa Séc`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `Denmark`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `Djibouti`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `Dominica`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'làm',
      'name': `Cộng hòa Dominica`,
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `Ecuador`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `Egypt`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `El Salvador`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `Guinea Xích đạo`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `Eritrea`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `Estonia`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `Ethiopia`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `Quần đảo Falkland (Quần đảo Malvinas)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `Quần đảo Faroe`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `Fiji`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `Finland`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `France`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `Guiana thuộc Pháp`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `Polynesia thuộc Pháp`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `Gabon`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `Gambia`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `Georgia`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'mã': 'de', 'name': `Đức`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `Ghana`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `Gibraltar`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'mã': 'gr', 'name': `Hy Lạp`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `Greenland (Quần đảo Karan)`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `Grenada`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `Guadeloupe`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `Guam`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `Guatemala`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `Guernsey`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `Guinea`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `Guinea-Bissau`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `Guyana`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `Haiti`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `Honduras`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `Hong Kong`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `Hungary`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `Iceland`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `India`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `Indonesia`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `Iran`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `Iraq`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `Ireland`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `Isle of Man`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `Israel`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `Italy`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `Jamaica`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `Japan`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `Jersey`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `Jordan`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `Kazakhstan`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `Kenya`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `Kiribati`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `Kosovo`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `Kuwait`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `Kyrgyzstan`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `Lào`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `Latvia`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `Lebanon`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `Lesotho`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `Liberia`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `Libya`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `Liechtenstein`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `Lithuania`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `Luxembourg`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `Macao`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `Macedonia`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `Madagascar`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `Malawi`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'mã': 'của tôi', 'name': `Malaysia`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `Maldives`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `Mali`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `Malta`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `Marshall Islands`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `Martinique`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `Mauritania`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `Mauritius`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `Mayotte`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `Mexico`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `Micronesia`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `Moldova (Cộng hòa Moldova)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `Monaco`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `Mongolia`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `người Montenegro`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `Montserrat`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `Morocco`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `Mozambique`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `Myanmar`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `Namibia`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `Nauru`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `Nepal`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `Netherlands`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `New Caledonia`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `New Zealand`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `Nicaragua`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `Niger`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `Nigeria`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `Niue`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `Norfolk Island`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `North Korea`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `Quần đảo Bắc Mariana`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `Na Uy`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `Oman`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `Pakistan`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `Palau`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `Palestine`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `Panama`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `Papua New Guinea`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `Paraguay`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `Peru`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `Philippines`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `Ba Lan`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `Portugal`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `Puerto Rico`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `Qatar`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `Reunion`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `Romania`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `Russia`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `Rwanda`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `Thánh Barthelemy`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `Saint Helena`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `Saint Kitts and Nevis`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `Saint Lucia`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `Saint Martin (phần tiếng Pháp)`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'chiều',
      'name': `Saint-Pierre và Miquelon`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `Saint Vincent và Grenadines`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `Samoa`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `San Marino`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `Sao Tome và Principe`,
      'dialCode': 239,
      'Định dạng điện thoại': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `Ả Rập Saudi`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `Senegal`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `Serbia`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `Seychelles`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `Sierra Leone`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `Singapore`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `Saint Martin`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `Slovakia`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `Slovenia`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `Solomon Islands`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `Somalia`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `Nam Phi`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `South Korea`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `Nam Sudan`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `Spain`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `Sri Lanka`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `Sudan`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `Suriname`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `Svalbard và Jan Mayen`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `Swaziland`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `Sweden`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `Switzerland`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `Syria`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `Taiwan`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `Tajikistan`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `Tanzania`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `Thailand`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `East Timor`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `Togo`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `Tokelau`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `Tonga`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `Trinidad and Tobago`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `Tunisia`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `Turkey`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `Turkmenistan`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `Quần đảo Turks và Caicos`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `Tuvalu`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `United States`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `United Kingdom`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `Quần đảo Virgin thuộc Hoa Kỳ`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `Uganda`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'mã': 'ua', 'name': `Ukraina`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'a',
      'name': `Các Tiểu vương quốc Ả Rập Thống nhất`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `Uruguay`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `Uzbekistan`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `Vanuatu`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `Vatican City`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `Venezuela`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `Vietnam`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `Wallis and Futuna`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'ơ',
      'name': `Tây Sahara`,
      'dialCode': 212,
      'Định dạng điện thoại': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `Yemen`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `Zambia`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `Zimbabwe`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `Aland Islands`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
  'italy': {
    'af': { 'code': 'af', 'name': `Afghanistan`, 'dialCode': 93, 'phoneFormat': '070 123 4567' },
    'al': { 'code': 'al', 'name': `Albania`, 'dialCode': 355, 'phoneFormat': '066 123 4567' },
    'dz': { 'code': 'dz', 'name': `Algeria`, 'dialCode': 213, 'phoneFormat': '0551 23 45 67' },
    'as': { 'code': 'as', 'name': `Samoa americane`, 'dialCode': 1684, 'phoneFormat': '(684) 733-1234' },
    'ad': { 'code': 'ad', 'name': `Andor`, 'dialCode': 376, 'phoneFormat': '312 345' },
    'ao': { 'code': 'ao', 'name': `Angola`, 'dialCode': 244, 'phoneFormat': '923 123 456' },
    'ai': { 'code': 'ai', 'name': `Anguilla`, 'dialCode': 1264, 'phoneFormat': '(264) 235-1234' },
    'ag': { 'code': 'ag', 'name': `Antigua e Barbuda`, 'dialCode': 1268, 'phoneFormat': '(268) 464-1234' },
    'ar': { 'code': 'ar', 'name': `Argentina`, 'dialCode': 54, 'phoneFormat': '011 15-2345-6789' },
    'am': { 'code': 'am', 'name': `Armenia`, 'dialCode': 374, 'phoneFormat': '077 123456' },
    'aw': { 'code': 'aw', 'name': `Aruba`, 'dialCode': 297, 'phoneFormat': '560 1234' },
    'au': { 'code': 'au', 'name': `Australia`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'at': { 'code': 'at', 'name': `Austria`, 'dialCode': 43, 'phoneFormat': '0664 123456' },
    'az': { 'code': 'az', 'name': `Azerbaijan`, 'dialCode': 994, 'phoneFormat': '040 123 45 67' },
    'bs': { 'code': 'bs', 'name': `Bahamas`, 'dialCode': 1242, 'phoneFormat': '(242) 359-1234' },
    'bh': { 'code': 'bh', 'name': `Bahrain`, 'dialCode': 973, 'phoneFormat': '3600 1234' },
    'bd': { 'code': 'bd', 'name': `Bangladesh`, 'dialCode': 880, 'phoneFormat': '01812-345678' },
    'bb': { 'code': 'bb', 'name': `Barbados`, 'dialCode': 1246, 'phoneFormat': '(246) 250-1234' },
    'by': { 'code': 'by', 'name': `Belarus`, 'dialCode': 375, 'phoneFormat': '8 029 491-19-11' },
    'be': { 'code': 'be', 'name': `Belgium`, 'dialCode': 32, 'phoneFormat': '0470 12 34 56' },
    'bz': { 'code': 'bz', 'name': `Belize`, 'dialCode': 501, 'phoneFormat': '622-1234' },
    'bj': { 'code': 'bj', 'name': `Benin`, 'dialCode': 229, 'phoneFormat': '90 01 12 34' },
    'bm': { 'code': 'bm', 'name': `Bermuda`, 'dialCode': 1441, 'phoneFormat': '(441) 370-1234' },
    'bt': { 'code': 'bt', 'name': `Bhutan`, 'dialCode': 975, 'phoneFormat': '17 12 34 56' },
    'bo': { 'code': 'bo', 'name': `Bolivia`, 'dialCode': 591, 'phoneFormat': '71234567' },
    'ba': {
      'code': 'ba',
      'name': `Bosnia ed Erzegovina`,
      'dialCode': 387,
      'phoneFormat': '061 123 456'
    },
    'bw': { 'code': 'bw', 'name': `Botswana`, 'dialCode': 267, 'phoneFormat': '71 123 456' },
    'br': { 'code': 'br', 'name': `Brazil`, 'dialCode': 55, 'phoneFormat': '(11) 96123-4567' },
    'io': { 'code': 'io', 'name': `Territorio britannico dell'Oceano Indiano`, 'dialCode': 246, 'phoneFormat': '380 1234' },
    'vg': { 'code': 'vg', 'name': `British Virgin Islands`, 'dialCode': 1284, 'phoneFormat': '(284) 300-1234' },
    'bn': { 'code': 'bn', 'name': `Brunei`, 'dialCode': 673, 'phoneFormat': '712 3456' },
    'bg': { 'code': 'bg', 'name': `Bulgaria`, 'dialCode': 359, 'phoneFormat': '048 123 456' },
    'bf': { 'code': 'bf', 'name': `Burkina Faso`, 'dialCode': 226, 'phoneFormat': '70 12 34 56' },
    'bi': { 'code': 'bi', 'name': `Burundi`, 'dialCode': 257, 'phoneFormat': '79 56 12 34' },
    'kh': { 'code': 'kh', 'name': `Cambodia`, 'dialCode': 855, 'phoneFormat': '091 234 567' },
    'cm': { 'code': 'cm', 'name': `Camerun`, 'dialCode': 237, 'phoneFormat': '6 71 23 45 67' },
    'ca': { 'code': 'ca', 'name': `Canada`, 'dialCode': 1, 'phoneFormat': '(204) 234-5678' },
    'cv': { 'code': 'cv', 'name': `Capo Verde`, 'dialCode': 238, 'phoneFormat': '991 12 34' },
    'bq': { 'code': 'bq', 'name': `Caribbean Netherlands`, 'dialCode': 599, 'phoneFormat': '318 1234' },
    'ky': { 'code': 'ky', 'name': `Cayman Islands`, 'dialCode': 1345, 'phoneFormat': '(345) 323-1234' },
    'cf': {
      'code': 'cf',
      'name': `Repubblica Centrafricana`,
      'dialCode': 236,
      'phoneFormat': '70 01 23 45'
    },
    'td': { 'code': 'td', 'name': `Chad`, 'dialCode': 235, 'phoneFormat': '63 01 23 45' },
    'cl': { 'code': 'cl', 'name': `Cile`, 'dialCode': 56, 'phoneFormat': '09 6123 4567' },
    'cn': { 'code': 'cn', 'name': `Cina (continente)`, 'dialCode': 86, 'phoneFormat': '131 2345 6789' },
    'cx': { 'code': 'cx', 'name': `Christmas Island`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'cc': { 'code': 'cc', 'name': `Isole Cocos (Keeling)`, 'dialCode': 61, 'phoneFormat': '0412 345 678' },
    'co': { 'code': 'co', 'name': `Colombia`, 'dialCode': 57, 'phoneFormat': '321 1234567' },
    'km': { 'code': 'km', 'name': `Comores`, 'dialCode': 269, 'phoneFormat': '321 23 45' },
    'cd': {
      'code': 'cd',
      'name': `Congo (Kinshasa)`,
      'dialCode': 243,
      'phoneFormat': '0991 234 567'
    },
    'cg': {
      'code': 'cg',
      'name': `Congo (Repubblica di)`,
      'dialCode': 242,
      'phoneFormat': '06 123 4567'
    },
    'ck': { 'code': 'ck', 'name': `Cook Islands`, 'dialCode': 682, 'phoneFormat': '71 234' },
    'cr': { 'code': 'cr', 'name': `Costa Rica`, 'dialCode': 506, 'phoneFormat': '8312 3456' },
    'ci': { 'code': 'ci', 'name': `Ivory Coast`, 'dialCode': 225, 'phoneFormat': '01 23 45 67' },
    'hr': { 'code': 'hr', 'name': `Croatia`, 'dialCode': 385, 'phoneFormat': '091 234 5678' },
    'cu': { 'code': 'cu', 'name': `Cuba`, 'dialCode': 53, 'phoneFormat': '05 1234567' },
    'cw': { 'code': 'cw', 'name': `Curaçao`, 'dialCode': 599, 'phoneFormat': '9 518 1234' },
    'cy': { 'code': 'cy', 'name': `Cyprus`, 'dialCode': 357, 'phoneFormat': '96 123456' },
    'cz': { 'code': 'cz', 'name': `Czech Republic`, 'dialCode': 420, 'phoneFormat': '601 123 456' },
    'dk': { 'code': 'dk', 'name': `Denmark`, 'dialCode': 45, 'phoneFormat': '20 12 34 56' },
    'dj': { 'code': 'dj', 'name': `Djibouti`, 'dialCode': 253, 'phoneFormat': '77 83 10 01' },
    'dm': { 'code': 'dm', 'name': `Dominica`, 'dialCode': 1767, 'phoneFormat': '(767) 225-1234' },
    'do': {
      'code': 'do',
      'name': "Repubblica Dominicana",
      'dialCode': 1,
      'phoneFormat': '(809) 234-5678'
    },
    'ec': { 'code': 'ec', 'name': `Ecuador`, 'dialCode': 593, 'phoneFormat': '099 123 4567' },
    'eg': { 'code': 'eg', 'name': `Egypt`, 'dialCode': 20, 'phoneFormat': '0100 123 4567' },
    'sv': { 'code': 'sv', 'name': `El Salvador`, 'dialCode': 503, 'phoneFormat': '7012 3456' },
    'gq': {
      'code': 'gq',
      'name': `Guinea Equatoriale`,
      'dialCode': 240,
      'phoneFormat': '222 123 456'
    },
    'er': { 'code': 'er', 'name': `Eritrea`, 'dialCode': 291, 'phoneFormat': '07 123 456' },
    'ee': { 'code': 'ee', 'name': `Estonia`, 'dialCode': 372, 'phoneFormat': '5123 4567' },
    'et': { 'code': 'et', 'name': `Ethiopia`, 'dialCode': 251, 'phoneFormat': '091 123 4567' },
    'fk': { 'code': 'fk', 'name': `Isole Falkland (Isole Malvinas)`, 'dialCode': 500, 'phoneFormat': '51234' },
    'fo': { 'code': 'fo', 'name': `Isole Faroe`, 'dialCode': 298, 'phoneFormat': '211234' },
    'fj': { 'code': 'fj', 'name': `Fiji`, 'dialCode': 679, 'phoneFormat': '701 2345' },
    'fi': { 'code': 'fi', 'name': `Finland`, 'dialCode': 358, 'phoneFormat': '041 2345678' },
    'fr': { 'code': 'fr', 'name': `France`, 'dialCode': 33, 'phoneFormat': '06 12 34 56 78' },
    'gf': { 'code': 'gf', 'name': `Guyana francese`, 'dialCode': 594, 'phoneFormat': '0694 20 12 34' },
    'pf': {
      'code': 'pf',
      'name': `Polinesia francese`,
      'dialCode': 689,
      'phoneFormat': '87 12 34 56'
    },
    'ga': { 'code': 'ga', 'name': `Gabon`, 'dialCode': 241, 'phoneFormat': '06 03 12 34' },
    'gm': { 'code': 'gm', 'name': `Gambia`, 'dialCode': 220, 'phoneFormat': '301 2345' },
    'ge': { 'code': 'ge', 'name': `Georgia`, 'dialCode': 995, 'phoneFormat': '555 12 34 56' },
    'de': { 'code': 'de', 'name': `Germany`, 'dialCode': 49, 'phoneFormat': '01512 3456789' },
    'gh': { 'code': 'gh', 'name': `Ghana`, 'dialCode': 233, 'phoneFormat': '023 123 4567' },
    'gi': { 'code': 'gi', 'name': `Gibraltar`, 'dialCode': 350, 'phoneFormat': '57123456' },
    'gr': { 'code': 'gr', 'name': `Greece`, 'dialCode': 30, 'phoneFormat': '691 234 5678' },
    'gl': { 'code': 'gl', 'name': `Groenlandia (Isole Karan)`, 'dialCode': 299, 'phoneFormat': '22 12 34' },
    'gd': { 'code': 'gd', 'name': `Grenada`, 'dialCode': 1473, 'phoneFormat': '(473) 403-1234' },
    'gp': { 'code': 'gp', 'name': `Guadaloupe`, 'dialCode': 590, 'phoneFormat': '0690 30-1234' },
    'gu': { 'code': 'gu', 'name': `Guam`, 'dialCode': 1671, 'phoneFormat': '(671) 300-1234' },
    'gt': { 'code': 'gt', 'name': `Guatemala`, 'dialCode': 502, 'phoneFormat': '5123 4567' },
    'gg': { 'code': 'gg', 'name': `Guernsey`, 'dialCode': 44, 'phoneFormat': '07781 123456' },
    'gn': { 'code': 'gn', 'name': `Guinea`, 'dialCode': 224, 'phoneFormat': '601 12 34 56' },
    'gw': { 'code': 'gw', 'name': `Guinea-Bissau`, 'dialCode': 245, 'phoneFormat': '955 012 345' },
    'gy': { 'code': 'gy', 'name': `Guyana`, 'dialCode': 592, 'phoneFormat': '609 1234' },
    'ht': { 'code': 'ht', 'name': `Haiti`, 'dialCode': 509, 'phoneFormat': '34 10 1234' },
    'hn': { 'code': 'hn', 'name': `Honduras`, 'dialCode': 504, 'phoneFormat': '9123-4567' },
    'hk': { 'code': 'hk', 'name': `Hong Kong`, 'dialCode': 852, 'phoneFormat': '5123 4567' },
    'hu': { 'code': 'hu', 'name': `Hungary`, 'dialCode': 36, 'phoneFormat': '(20) 123 4567' },
    'is': { 'code': 'is', 'name': `Iceland`, 'dialCode': 354, 'phoneFormat': '611 1234' },
    'in': { 'code': 'in', 'name': `India`, 'dialCode': 91, 'phoneFormat': '099876 54321' },
    'id': { 'code': 'id', 'name': `Indonesia`, 'dialCode': 62, 'phoneFormat': '0812-345-678' },
    'ir': { 'code': 'ir', 'name': `Iran`, 'dialCode': 98, 'phoneFormat': '0912 345 6789' },
    'iq': { 'code': 'iq', 'name': `Iraq`, 'dialCode': 964, 'phoneFormat': '0791 234 5678' },
    'ie': { 'code': 'ie', 'name': `Ireland`, 'dialCode': 353, 'phoneFormat': '085 012 3456' },
    'im': { 'code': 'im', 'name': `Isola di Man`, 'dialCode': 44, 'phoneFormat': '07924 123456' },
    'il': { 'code': 'il', 'name': `Israel`, 'dialCode': 972, 'phoneFormat': '050-123-4567' },
    'it': { 'code': 'it', 'name': `Italy`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    'jm': { 'code': 'jm', 'name': `Jamaica`, 'dialCode': 1876, 'phoneFormat': '(876) 210-1234' },
    'jp': { 'code': 'jp', 'name': `Japan`, 'dialCode': 81, 'phoneFormat': '090-1234-5678' },
    'je': { 'code': 'je', 'name': `Jersey`, 'dialCode': 44, 'phoneFormat': '07797 123456' },
    'jo': { 'code': 'jo', 'name': `Jordan`, 'dialCode': 962, 'phoneFormat': '07 9012 3456' },
    'kz': { 'code': 'kz', 'name': `Kazakhstan`, 'dialCode': 7, 'phoneFormat': '8 (771) 000 9998' },
    'ke': { 'code': 'ke', 'name': `Kenya`, 'dialCode': 254, 'phoneFormat': '0712 123456' },
    'ki': { 'code': 'ki', 'name': `Kiribati`, 'dialCode': 686, 'phoneFormat': '72012345' },
    'xk': { 'code': 'xk', 'name': `Kosovo`, 'dialCode': 383, 'phoneFormat': '' },
    'kw': { 'code': 'kw', 'name': `Kuwait`, 'dialCode': 965, 'phoneFormat': '500 12345' },
    'kg': { 'code': 'kg', 'name': `Kyrgyzstan`, 'dialCode': 996, 'phoneFormat': '0700 123 456' },
    'la': { 'code': 'la', 'name': `Laos`, 'dialCode': 856, 'phoneFormat': '020 23 123 456' },
    'lv': { 'code': 'lv', 'name': `Lettonia`, 'dialCode': 371, 'phoneFormat': '21 234 567' },
    'lb': { 'code': 'lb', 'name': `Lebanon`, 'dialCode': 961, 'phoneFormat': '71 123 456' },
    'ls': { 'code': 'ls', 'name': `Lesotho`, 'dialCode': 266, 'phoneFormat': '5012 3456' },
    'lr': { 'code': 'lr', 'name': `Liberia`, 'dialCode': 231, 'phoneFormat': '077 012 3456' },
    'ly': { 'code': 'ly', 'name': `Libya`, 'dialCode': 218, 'phoneFormat': '091-2345678' },
    'li': { 'code': 'li', 'name': `Liechtenstein`, 'dialCode': 423, 'phoneFormat': '660 234 567' },
    'lt': { 'code': 'lt', 'name': `Lituania`, 'dialCode': 370, 'phoneFormat': '(8-612) 34567' },
    'lu': { 'code': 'lu', 'name': `Luxembourg`, 'dialCode': 352, 'phoneFormat': '628 123 456' },
    'mo': { 'code': 'mo', 'name': `Macao`, 'dialCode': 853, 'phoneFormat': '6612 3456' },
    'mk': { 'code': 'mk', 'name': `Macedonia`, 'dialCode': 389, 'phoneFormat': '072 345 678' },
    'mg': { 'code': 'mg', 'name': `Madagascar`, 'dialCode': 261, 'phoneFormat': '032 12 345 67' },
    'mw': { 'code': 'mw', 'name': `Malawi`, 'dialCode': 265, 'phoneFormat': '0991 23 45 67' },
    'my': { 'code': 'my', 'name': `Malaysia`, 'dialCode': 60, 'phoneFormat': '012-345 6789' },
    'mv': { 'code': 'mv', 'name': `Maldive`, 'dialCode': 960, 'phoneFormat': '771-2345' },
    'ml': { 'code': 'ml', 'name': `Mali`, 'dialCode': 223, 'phoneFormat': '65 01 23 45' },
    'mt': { 'code': 'mt', 'name': `Malta`, 'dialCode': 356, 'phoneFormat': '9696 1234' },
    'mh': { 'code': 'mh', 'name': `Marshall Islands`, 'dialCode': 692, 'phoneFormat': '235-1234' },
    'mq': { 'code': 'mq', 'name': `Martinique`, 'dialCode': 596, 'phoneFormat': '0696 20 12 34' },
    'mr': { 'code': 'mr', 'name': `Mauritania`, 'dialCode': 222, 'phoneFormat': '22 12 34 56' },
    'mu': { 'code': 'mu', 'name': `Mauritius`, 'dialCode': 230, 'phoneFormat': '5251 2345' },
    'yt': { 'code': 'yt', 'name': `Mayotte`, 'dialCode': 262, 'phoneFormat': '0639 12 34 56' },
    'mx': { 'code': 'mx', 'name': `Mexico`, 'dialCode': 52, 'phoneFormat': '044 222 123 4567' },
    'fm': { 'code': 'fm', 'name': `Micronesia`, 'dialCode': 691, 'phoneFormat': '350 1234' },
    'md': { 'code': 'md', 'name': `Moldova (Repubblica di Moldova)`, 'dialCode': 373, 'phoneFormat': '0621 12 345' },
    'mc': { 'code': 'mc', 'name': `Monaco`, 'dialCode': 377, 'phoneFormat': '06 12 34 56 78' },
    'mn': { 'code': 'mn', 'name': `Mongolia`, 'dialCode': 976, 'phoneFormat': '8812 3456' },
    'me': { 'code': 'me', 'name': `Montenegro`, 'dialCode': 382, 'phoneFormat': '067 622 901' },
    'ms': { 'code': 'ms', 'name': `Montserrat`, 'dialCode': 1664, 'phoneFormat': '(664) 492-3456' },
    'ma': { 'code': 'ma', 'name': `Morocco`, 'dialCode': 212, 'phoneFormat': '0650-123456' },
    'mz': { 'code': 'mz', 'name': `Mozambique`, 'dialCode': 258, 'phoneFormat': '82 123 4567' },
    'mm': { 'code': 'mm', 'name': `Myanmar`, 'dialCode': 95, 'phoneFormat': '09 212 3456' },
    'na': { 'code': 'na', 'name': `Namibia`, 'dialCode': 264, 'phoneFormat': '081 123 4567' },
    'nr': { 'code': 'nr', 'name': `Nauru`, 'dialCode': 674, 'phoneFormat': '555 1234' },
    'np': { 'code': 'np', 'name': `Nepal`, 'dialCode': 977, 'phoneFormat': '984-1234567' },
    'nl': { 'code': 'nl', 'name': `Netherlands`, 'dialCode': 31, 'phoneFormat': '06 12345678' },
    'nc': { 'code': 'nc', 'name': `Nuova Caledonia`, 'dialCode': 687, 'phoneFormat': '75.12.34' },
    'nz': { 'code': 'nz', 'name': `New Zealand`, 'dialCode': 64, 'phoneFormat': '021 123 4567' },
    'ni': { 'code': 'ni', 'name': `Nicaragua`, 'dialCode': 505, 'phoneFormat': '8123 4567' },
    'ne': { 'code': 'ne', 'name': `Niger`, 'dialCode': 227, 'phoneFormat': '93 12 34 56' },
    'ng': { 'code': 'ng', 'name': `Nigeria`, 'dialCode': 234, 'phoneFormat': '0802 123 4567' },
    'nu': { 'code': 'nu', 'name': `Niue`, 'dialCode': 683, 'phoneFormat': '1234' },
    'nf': { 'code': 'nf', 'name': `Norfolk Island`, 'dialCode': 672, 'phoneFormat': '3 81234' },
    'kp': { 'code': 'kp', 'name': `Corea del Nord`, 'dialCode': 850, 'phoneFormat': '0192 123 4567' },
    'mp': { 'code': 'mp', 'name': `Isole Marianne Settentrionali`, 'dialCode': 1670, 'phoneFormat': '(670) 234-5678' },
    'no': { 'code': 'no', 'name': `Norway`, 'dialCode': 47, 'phoneFormat': '406 12 345' },
    'om': { 'code': 'om', 'name': `Oman`, 'dialCode': 968, 'phoneFormat': '9212 3456' },
    'pk': { 'code': 'pk', 'name': `Pakistan`, 'dialCode': 92, 'phoneFormat': '0301 2345678' },
    'pw': { 'code': 'pw', 'name': `Palau`, 'dialCode': 680, 'phoneFormat': '620 1234' },
    'ps': { 'code': 'ps', 'name': `Palestine`, 'dialCode': 970, 'phoneFormat': '0599 123 456' },
    'pa': { 'code': 'pa', 'name': `Panama`, 'dialCode': 507, 'phoneFormat': '6001-2345' },
    'pg': { 'code': 'pg', 'name': `Papua New Guinea`, 'dialCode': 675, 'phoneFormat': '681 2345' },
    'py': { 'code': 'py', 'name': `Paraguay`, 'dialCode': 595, 'phoneFormat': '0961 456789' },
    'pe': { 'code': 'pe', 'name': `Peru`, 'dialCode': 51, 'phoneFormat': '912 345 678' },
    'ph': { 'code': 'ph', 'name': `Philippines`, 'dialCode': 63, 'phoneFormat': '0905 123 4567' },
    'pl': { 'code': 'pl', 'name': `Poland`, 'dialCode': 48, 'phoneFormat': '512 345 678' },
    'pt': { 'code': 'pt', 'name': `Portugal`, 'dialCode': 351, 'phoneFormat': '912 345 678' },
    'pr': { 'code': 'pr', 'name': `Puerto Rico`, 'dialCode': 1, 'phoneFormat': '(787) 234-5678' },
    'qa': { 'code': 'qa', 'name': `Qatar`, 'dialCode': 974, 'phoneFormat': '3312 3456' },
    're': { 'code': 're', 'name': `Reunion`, 'dialCode': 262, 'phoneFormat': '0692 12 34 56' },
    'ro': { 'code': 'ro', 'name': `Romania`, 'dialCode': 40, 'phoneFormat': '0712 345 678' },
    'ru': { 'code': 'ru', 'name': `Russia`, 'dialCode': 7, 'phoneFormat': '8 (912) 345-67-89' },
    'rw': { 'code': 'rw', 'name': `Rwanda`, 'dialCode': 250, 'phoneFormat': '0720 123 456' },
    'bl': {
      'code': 'bl',
      'name': `Saint Barthelemy`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'sh': { 'code': 'sh', 'name': `Sant'Elena`, 'dialCode': 290, 'phoneFormat': '51234' },
    'kn': { 'code': 'kn', 'name': `Saint Kitts e Nevis`, 'dialCode': 1869, 'phoneFormat': '(869) 765-2917' },
    'lc': { 'code': 'lc', 'name': `Santa Lucia`, 'dialCode': 1758, 'phoneFormat': '(758) 284-5678' },
    'mf': {
      'code': 'mf',
      'name': `Saint Martin (parte francese)`,
      'dialCode': 590,
      'phoneFormat': '0690 30-1234'
    },
    'pm': {
      'code': 'pm',
      'name': `Saint-Pierre e Miquelon`,
      'dialCode': 508,
      'phoneFormat': '055 12 34'
    },
    'vc': {
      'code': 'vc',
      'name': `Saint Vincent e Grenadine`,
      'dialCode': 1784,
      'phoneFormat': '(784) 430-1234'
    },
    'ws': { 'code': 'ws', 'name': `Samoa`, 'dialCode': 685, 'phoneFormat': '601234' },
    'sm': { 'code': 'sm', 'name': `San Marino`, 'dialCode': 378, 'phoneFormat': '66 66 12 12' },
    'st': {
      'code': 'st',
      'name': `Sao Tome e Principe`,
      'dialCode': 239,
      'phoneFormat': '981 2345'
    },
    'sa': {
      'code': 'sa',
      'name': `Arabia Saudita`,
      'dialCode': 966,
      'phoneFormat': '051 234 5678'
    },
    'sn': { 'code': 'sn', 'name': `Senegal`, 'dialCode': 221, 'phoneFormat': '70 123 45 67' },
    'rs': { 'code': 'rs', 'name': `Serbia`, 'dialCode': 381, 'phoneFormat': '060 1234567' },
    'sc': { 'code': 'sc', 'name': `Seychelles`, 'dialCode': 248, 'phoneFormat': '2 510 123' },
    'sl': { 'code': 'sl', 'name': `Sierra Leone`, 'dialCode': 232, 'phoneFormat': '(025) 123456' },
    'sg': { 'code': 'sg', 'name': `Singapore`, 'dialCode': 65, 'phoneFormat': '8123 4567' },
    'sx': { 'code': 'sx', 'name': `Saint Martin`, 'dialCode': 1721, 'phoneFormat': '(721) 520-5678' },
    'sk': { 'code': 'sk', 'name': `Slovakia`, 'dialCode': 421, 'phoneFormat': '0912 123 456' },
    'si': { 'code': 'si', 'name': `Slovenia`, 'dialCode': 386, 'phoneFormat': '031 234 567' },
    'sb': { 'code': 'sb', 'name': `Solomon Islands`, 'dialCode': 677, 'phoneFormat': '74 21234' },
    'so': { 'code': 'so', 'name': `Somalia`, 'dialCode': 252, 'phoneFormat': '7 1123456' },
    'za': { 'code': 'za', 'name': `South Africa`, 'dialCode': 27, 'phoneFormat': '071 123 4567' },
    'kr': { 'code': 'kr', 'name': `South Korea`, 'dialCode': 82, 'phoneFormat': '010-0000-0000' },
    'ss': { 'code': 'ss', 'name': `South Sudan`, 'dialCode': 211, 'phoneFormat': '0977 123 456' },
    'es': { 'code': 'es', 'name': `Spain`, 'dialCode': 34, 'phoneFormat': '612 34 56 78' },
    'lk': { 'code': 'lk', 'name': `Sri Lanka`, 'dialCode': 94, 'phoneFormat': '071 234 5678' },
    'sd': { 'code': 'sd', 'name': `Sudan`, 'dialCode': 249, 'phoneFormat': '091 123 1234' },
    'sr': { 'code': 'sr', 'name': `Suriname`, 'dialCode': 597, 'phoneFormat': '741-2345' },
    'sj': { 'code': 'sj', 'name': `Svalbard e Jan Mayen`, 'dialCode': 47, 'phoneFormat': '412 34 567' },
    'sz': { 'code': 'sz', 'name': `Swaziland`, 'dialCode': 268, 'phoneFormat': '7612 3456' },
    'se': { 'code': 'se', 'name': `Sweden`, 'dialCode': 46, 'phoneFormat': '070-123 45 67' },
    'ch': { 'code': 'ch', 'name': `Switzerland`, 'dialCode': 41, 'phoneFormat': '078 123 45 67' },
    'sy': { 'code': 'sy', 'name': `Syria`, 'dialCode': 963, 'phoneFormat': '0944 567 890' },
    'tw': { 'code': 'tw', 'name': `Taiwan`, 'dialCode': 886, 'phoneFormat': '0912 345 678' },
    'tj': { 'code': 'tj', 'name': `Tagikistan`, 'dialCode': 992, 'phoneFormat': '(8) 917 12 3456' },
    'tz': { 'code': 'tz', 'name': `Tanzania`, 'dialCode': 255, 'phoneFormat': '0621 234 567' },
    'th': { 'code': 'th', 'name': `Thailand`, 'dialCode': 66, 'phoneFormat': '081 234 5678' },
    'tl': { 'code': 'tl', 'name': `Timor Est`, 'dialCode': 670, 'phoneFormat': '7721 2345' },
    'tg': { 'code': 'tg', 'name': `Togo`, 'dialCode': 228, 'phoneFormat': '90 11 23 45' },
    'tk': { 'code': 'tk', 'name': `Tokelau`, 'dialCode': 690, 'phoneFormat': '7290' },
    'to': { 'code': 'to', 'name': `Tonga`, 'dialCode': 676, 'phoneFormat': '771 5123' },
    'tt': { 'code': 'tt', 'name': `Trinidad e Tobago`, 'dialCode': 1868, 'phoneFormat': '(868) 291-1234' },
    'tn': { 'code': 'tn', 'name': `Tunisia`, 'dialCode': 216, 'phoneFormat': '20 123 456' },
    'tr': { 'code': 'tr', 'name': `Turkey`, 'dialCode': 90, 'phoneFormat': '0501 234 56 78' },
    'tm': { 'code': 'tm', 'name': `Turkmenistan`, 'dialCode': 993, 'phoneFormat': '8 66 123456' },
    'tc': { 'code': 'tc', 'name': `Isole Turks e Caicos`, 'dialCode': 1649, 'phoneFormat': '(649) 231-1234' },
    'tv': { 'code': 'tv', 'name': `Tuvalu`, 'dialCode': 688, 'phoneFormat': '901234' },
    'us': { 'code': 'us', 'name': `United States`, 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
    'gb': { 'code': 'gb', 'name': `Regno Unito`, 'dialCode': 44, 'phoneFormat': '07400 123456' },
    'vi': { 'code': 'vi', 'name': `Isole Vergini americane`, 'dialCode': 1340, 'phoneFormat': '(340) 642-1234' },
    'ug': { 'code': 'ug', 'name': `Uganda`, 'dialCode': 256, 'phoneFormat': '0712 345678' },
    'ua': { 'code': 'ua', 'name': `Ukraine`, 'dialCode': 380, 'phoneFormat': '039 123 4567' },
    'ae': {
      'code': 'ae',
      'name': `Emirati Arabi Uniti`,
      'dialCode': 971,
      'phoneFormat': '050 123 4567'
    },
    'uy': { 'code': 'uy', 'name': `Uruguay`, 'dialCode': 598, 'phoneFormat': '094 231 234' },
    'uz': { 'code': 'uz', 'name': `Uzbekistan`, 'dialCode': 998, 'phoneFormat': '8 91 234 56 78' },
    'vu': { 'code': 'vu', 'name': `Vanuatu`, 'dialCode': 678, 'phoneFormat': '591 2345' },
    'va': { 'code': 'va', 'name': `Vatican City`, 'dialCode': 39, 'phoneFormat': '312 345 6789' },
    've': { 'code': 've', 'name': `Venezuela`, 'dialCode': 58, 'phoneFormat': '0412-1234567' },
    'vn': { 'code': 'vn', 'name': `Vietnam`, 'dialCode': 84, 'phoneFormat': '091 234 56 78' },
    'wf': { 'code': 'wf', 'name': `Wallis e Futuna`, 'dialCode': 681, 'phoneFormat': '50 12 34' },
    'eh': {
      'code': 'eh',
      'name': `Sahara occidentale`,
      'dialCode': 212,
      'phoneFormat': '0650-123456'
    },
    'ye': { 'code': 'ye', 'name': `Yemen`, 'dialCode': 967, 'phoneFormat': '0712 345 678' },
    'zm': { 'code': 'zm', 'name': `Zambia`, 'dialCode': 260, 'phoneFormat': '095 5123456' },
    'zw': { 'code': 'zw', 'name': `Zimbabwe`, 'dialCode': 263, 'phoneFormat': '071 123 4567' },
    'ax': { 'code': 'ax', 'name': `Isole Aland`, 'dialCode': 358, 'phoneFormat': '041 2345678' }
  },
}

export default countries


// WEBPACK FOOTER //
// ./src/components/countryList.js